const messages = {
        en: {
          translations: {
            common: {
              yes: "Yes",
              no: "No",
              clean: "Clean",
              connection: "Connection"
            },
            enterprisePlan: {
              title: "Enterprise",
              pricing: "Custom pricing",
              description: "Tailored plan for high-volume teams",
              ctaContactSales: "Contact Sales"
            },
            buttons: {
              cancel: "Cancel",
              close: "Close",
              save: "Save",
              confirm: "Confirm",
              ok: "OK",
              import: "Import",
              all: "All"
            },
            signup: {
              title: "Sign Up",
              toasts: {
                success: "User created successfully! Log in now!!!",
                fail: "Error creating user. Check the provided data."
              },
              form: {
                name: "Name",
                email: "Email",
                password: "Password"
              },
              buttons: {
                submit: "Sign Up",
                login: "Already have an account? Log in!"
              }
            },
            admin: {
              tag: "Admin",
              exit: "Exit to workspace",
              enterSoftware: "Enter software",
              nav: {
                heading: "Platform",
                overview: "Overview",
                companies: "Companies",
                plans: "Plans",
                subscriptions: "Subscriptions",
                audit: "Audit log",
                compare: "Compare",
                broadcasts: "Broadcasts",
                pages: "Pages"
              },
              broadcast: {
                title: "Broadcasts",
                subtitle: "Platform-wide or per-tenant announcement banners",
                refresh: "Refresh",
                compose: "New broadcast",
                publish: "Publish",
                publishing: "Publishing…",
                cancel: "Cancel",
                empty: "No broadcasts yet. Compose the first one above.",
                loadError: "Could not load notifications.",
                actionFailed: "Action failed",
                createFailed: "Could not publish notification.",
                titleBodyRequired: "Title and body are required.",
                tenantTargetRequired: "Pick a target company for tenant-scoped broadcasts.",
                created: "Notification published.",
                confirmDelete: "Delete \"{{title}}\"? This cannot be undone.",
                endsOn: "until {{date}}",
                col: {
                  title: "Message",
                  severity: "Severity",
                  audience: "Audience",
                  created: "Created",
                  actions: "Actions"
                },
                audience: {
                  all: "All tenants",
                  tenant: "Specific tenant"
                },
                form: {
                  title: "Title",
                  body: "Body",
                  severity: "Severity",
                  audience: "Audience",
                  target: "Target company",
                  endsAt: "Expires on (optional)"
                },
                tooltip: {
                  active: "Active (tap to stop)",
                  stopped: "Stopped (tap to activate)"
                },
                aria: {
                  active: "Broadcast is active",
                  stopped: "Broadcast is stopped"
                }
              },
              compare: {
                title: "Compare tenants",
                subtitle: "{{count}} of {{max}} selected · operational KPIs side by side",
                add: "Add tenant",
                remove: "Remove",
                searchPlaceholder: "Search by company name…",
                pickerEmpty: "No companies match.",
                noPlan: "No plan",
                slotEmpty: "—",
                empty: {
                  title: "Pick tenants to compare",
                  sub: "Add up to 4 companies — their operational KPIs will line up side by side."
                },
                row: {
                  metric: "Metric",
                  status: "Health",
                  msgs24h: "Msgs 24h",
                  tickets: "Open tickets",
                  closed24h: "{{count}} closed",
                  whatsapp: "WhatsApp",
                  users: "Users",
                  queuesN: "{{count}} queues",
                  ai: "AI worker",
                  spark: "Volume 7d"
                }
              },
              audit: {
                title: "Audit log",
                subtitle: "Every platform-operator action across all tenants",
                refresh: "Refresh",
                reset: "Reset",
                empty: "No audit entries match your filters.",
                filter: {
                  action: "Action",
                  allActions: "All actions",
                  admin: "Admin",
                  allAdmins: "All admins",
                  since: "From",
                  until: "To"
                },
                col: {
                  when: "When",
                  admin: "Admin",
                  action: "Action",
                  target: "Target",
                  ip: "IP"
                },
                pagination: {
                  showing: "Showing {{start}}–{{end}} of {{total}}",
                  prev: "Previous",
                  next: "Next"
                }
              },
              overview: {
                title: "Companies overview",
                subtitle: "Platform-level metrics across all tenants",
                loadError: "Could not load overview. Try refreshing.",
                empty: "No data yet.",
                kpi: {
                  companies: "Companies",
                  active: "Active",
                  expiringSoon: "Expiring soon",
                  within7Days: "Within 7 days",
                  mrr: "MRR (est.)",
                  mrrSub: "Monthly equivalent",
                  newThisMonth: "+{{count}} this month"
                },
                signups: {
                  title: "Signups (last 6 months)",
                  sub: "New companies per month"
                },
                plans: {
                  title: "Plan distribution",
                  sub: "Share of companies per tier"
                },
                expiring: {
                  title: "Expiring soon",
                  viewAll: "View all",
                  empty: "No expirations in the next 7 days.",
                  today: "today",
                  tomorrow: "tomorrow",
                  inDays: "in {{days}} days"
                },
                attention: {
                  title: "Needs attention",
                  sub: "Counts only — open Companies to act",
                  suspended: "Suspended",
                  pastDue: "Past due date",
                  aiOff: "AI disabled",
                  openCompanies: "Open Companies"
                },
                activity: {
                  title: "Recent platform activity",
                  viewAll: "View full audit log",
                  empty: "No platform actions recorded yet.",
                  now: "just now",
                  minAgo: "{{count}}m ago",
                  hAgo: "{{count}}h ago",
                  dAgo: "{{count}}d ago"
                }
              },
              health: {
                backToCompanies: "Back to Companies",
                loadError: "Could not load tenant health.",
                actionFailed: "Action failed",
                justNow: "now",
                status: {
                  healthy: "Healthy",
                  watch: "Watch",
                  critical: "Critical"
                },
                reason: {
                  suspended: "suspended",
                  no_whatsapp_session: "no WhatsApp session",
                  whatsapp_disconnected: "WhatsApp disconnected",
                  no_activity_24h: "no activity 24h",
                  past_due: "past due date",
                  expiring_soon: "expiring soon"
                },
                kpi: {
                  msgs24h: "Messages (24h)",
                  totalLast24h: "Inbound + outbound",
                  ticketsOpen: "Open tickets",
                  closed24h: "{{count}} closed in 24h",
                  whatsapps: "WhatsApp",
                  connectedTotal: "Connected / total",
                  users: "Users",
                  queues: "{{count}} queues"
                },
                volume: {
                  title: "Message volume (last 7 days)",
                  sub: "Daily totals — counts only"
                },
                config: {
                  title: "Configuration",
                  sub: "Metadata only",
                  ai: "AI worker",
                  aiPromptSize: "AI prompt size",
                  chars: "chars",
                  queues: "Queues",
                  settings: "Settings rows",
                  dueDate: "Due date",
                  on: "On",
                  off: "Off"
                },
                activity: {
                  title: "Recent admin actions",
                  sub: "Platform operators only",
                  empty: "No platform actions recorded for this tenant.",
                  byUser: "by admin #{{id}}"
                },
                action: {
                  impersonate: "Login as tenant",
                  ai_enable: "AI enabled",
                  ai_disable: "AI disabled",
                  suspend_tenant: "Suspended",
                  reactivate_tenant: "Reactivated"
                },
                actions: {
                  enableAi: "Enable AI",
                  disableAi: "Disable AI",
                  suspend: "Suspend",
                  reactivate: "Reactivate"
                },
                aiToggle: {
                  enabled: "AI enabled",
                  disabled: "AI disabled"
                },
                confirm: {
                  suspend: "Suspend {{name}}? They won't be able to log in.",
                  reactivate: "Reactivate {{name}}?"
                },
                suspended: "Suspended",
                reactivated: "Reactivated",
                toggleAiTip: "Enable or disable AI worker for this tenant"
              }
            },
            login: {
              title: "Welcome back",
              subtitle: "Sign in to continue to your workspace",
              form: {
                email: "Email",
                password: "Password",
                remember: "Remember me",
                forgot: "Forgot password?"
              },
              buttons: {
                submit: "Log In",
                register: "Don't have an account? Sign up!",
                haveAccount: "New here?"
              },
              brand: {
                meta: "WhatsApp CRM",
                h1: "Conversations",
                h2a: "that ",
                h2b: "close",
                h3: "deals.",
                subhead: "AI-powered WhatsApp CRM that helps you manage, automate and close more deals — all in one place.",
                f1: {
                  t: "All conversations in one place",
                  b: "Never miss a message. Stay organized."
                },
                f2: {
                  t: "Automate and save time",
                  b: "Smart automation for faster results."
                },
                f3: {
                  t: "Insights that drive growth",
                  b: "Know more, decide better, close more."
                }
              },
              secure: {
                title: "Secure & encrypted",
                body: "Your data is safe with us"
              }
            },
            companies: {
              title: "Register Company",
              form: {
                name: "Company Name",
                plan: "Plan",
                token: "Token",
                submit: "Register",
                success: "Company created successfully!"
              }
            },
            plansManager: {
              form: {
                name: "Plan Name",
                isPublic: "Public",
                value: "Price",
                users: "Users",
                connections: "Connections",
                queues: "Queues",
                options: {
                  yes: "Yes",
                  no: "No"
                },
                buttons: {
                  clear: "Clear",
                  delete: "Delete",
                  save: "Save"
                }
              },
              table: {
                name: "Name",
                users: "Users",
                isPublic: "Public",
                connections: "Connections",
                queues: "Queues",
                value: "Price"
              },
              toasts: {
                loadError: "Unable to load the plans list.",
                success: "Operation completed successfully!",
                saveError: "The operation could not be completed. Check for duplicate plan names or invalid fields.",
                deleteError: "The operation could not be completed."
              },
              confirmation: {
                title: "Delete Confirmation",
                message: "Are you sure you want to delete this record?"
              }
            },
            companiesManager: {
              form: {
                name: "Name",
                email: "E-mail",
                phone: "Phone",
                plan: "Plan",
                status: "Status",
                expiration: "Expiration Date"
              },
              table: {
                name: "Name",
                email: "E-mail",
                phone: "Phone",
                plan: "Plan",
                status: "Status",
                createdAt: "Created At",
                expiration: "Expiration"
              }
            },
            auth: {
              toasts: {
                success: "Login successful!"
              },
              token: "Token"
            },
            dashboard: {
              title: "WhatsApp CRM Dashboard",
              unassigned: "Unassigned",
              others: "Others",
              other: "Other",
              status: {
                open: "Open",
                pending: "Pending",
                closed: "Closed",
                unknown: "Unknown",
                online: "Online",
                offline: "Offline"
              },
              charts: {
                perDay: {
                  title: "Today's Interactions: "
                },
                filters: {
                  button: "Filter",
                  startDate: "Start Date",
                  endDate: "End Date",
                  periodText: "Period",
                  periodOptions: {
                    input: "Select desired period",
                    zero: "No period selected",
                    three: "Last 3",
                    seven: "Last 7",
                    fifteen: "Last 15",
                    thirty: "Last 30",
                    sixty: "Last 60",
                    ninety: "Last 90"
                  },
                  choosePeriod: "Select the desired period",
                  selectError: "Select at least one filter option.",
                  quickRanges: {
                    day: "Day",
                    threeDays: "3 Days",
                    week: "Week",
                    twoWeeks: "2 Weeks",
                    month: "Month",
                    threeMonths: "3 Months",
                    all: "All Time"
                  },
                  duedate: "Due Date",
                  filtertype: {
                    title: "Filter Type",
                    valueA: "Filter by date",
                    valueB: "Filter by period",
                    helperText: "Select desired period"
                  }
                },
                noData: "No data available",
                dayNames: {
                  full: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                  short: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
                },
                titles: {
                  tagsDistribution: "Tickets by Tag",
                  statusDistribution: "New Tickets by Status",
                  queueDistribution: "Tickets per Queue",
                  userDistribution: "Tickets per User",
                  dayDistribution: "Tickets per Day of Week",
                  messagesToday: "Messages Received Today",
                  newMessagesReceived: "New Messages Received"
                }
              },
              cards: {
                attdPendants: "Pending Tickets",
                attdHappening: "Active Tickets",
                attdPerformed: "Closed Tickets",
                attdWaiting: "Waiting Tickets",
                leads: "Leads",
                mtofService: "Average Service Time",
                mtofwaiting: "Average Waiting Time",
                total: "Total Tickets"
              },
              campaigns: {
                title: "Campaigns Overview",
                total: "Total Campaigns",
                sent: "Messages Sent",
                delivered: "Delivered",
                read: "Read",
                readRate: "Read Rate",
                active: "Active",
                completed: "Completed",
                failed: "Failed"
              },
              gptAnalytics: {
                title: "AI Analytics",
                refresh: "Refresh Analytics",
                refreshed: "Analytics refreshed",
                error: "Error loading analytics",
                noData: "No ticket data available for analysis",
                resolutionRate: "Resolution Rate",
                avgResponseTime: "Avg Response",
                activeTickets: "Active",
                waitingTickets: "Pending",
                overallSentiment: "Overall Sentiment Analysis",
                aiInsights: "AI Insights",
                showMore: "Show More Details",
                showLess: "Show Less",
                topPerformer: "Top Performer",
                closed: "closed",
                queueDistribution: "Queue Distribution",
                lastUpdated: "Last updated",
                insights: {
                  highResolution: "Excellent resolution rate!",
                  lowResolution: "Resolution rate needs improvement",
                  manyPending: "Many tickets waiting for response",
                  ticketsClosed: "tickets closed",
                  slowResponse: "Response time is above average",
                  fastResponse: "Fast response time!"
                }
              },
              table: {
                name: "Name",
                calif: "Ratings",
                total: "Total",
                current: "Active Tickets",
                closed: "Closed Tickets",
                timemedia: "Average Service Time",
                waiting: "Average Waiting Time",
                statuschat: "Status (Current)",
                openCalls: "Open Calls",
                closedCalls: "Closed Calls",
                totalCalls: "Total Calls",
                connected: "Connected",
                disconnected: "Disconnected",
                newCallsByDate: "New Calls by Date",
                status: "Status",
                tickets: "Tickets",
                avgHandle: "Avg handle time",
                rating: "Rating",
                section: "Tab",
                avgHandleTime: "Avg handle time",
                closeRate: "Close rate",
                openCount: "Open",
                avgWait: "Wait time"
              },
              tooltip: {
                ticketsCount: "{{count}} tickets"
              },
              ticketsByHour: {
                title: "Tickets per Hour",
                formatButton: "Format: {{value}}",
                formatOptions: {
                  twelve: "12h",
                  twentyFour: "24h"
                },
                chartTypes: {
                  bar: "Columns",
                  line: "Line",
                  area: "Area"
                },
                legend: {
                  businessHours: "Business Hours (9:00-18:00)",
                  outOfHours: "Out of Hours"
                },
                stats: {
                  title: "Hourly Statistics",
                  peakHour: "Peak Hour",
                  peakHourCount: "{{count}} tickets",
                  businessHours: "Business Hours",
                  businessHoursSuffix: "of total tickets",
                  outOfHours: "Out of Hours",
                  outOfHoursSuffix: "of total tickets",
                  averagePerHour: "Average per Hour",
                  averagePerHourSuffix: "tickets per hour"
                },
                seriesName: "Tickets"
              },
              subtitle: "Here's a live snapshot of your team",
              greet: {
                morning: "Good morning",
                afternoon: "Good afternoon",
                evening: "Good evening",
                night: "Good night"
              },
              range: {
                today: "Today",
                yesterday: "Yesterday",
                "7d": "7 days",
                "30d": "30 days",
                "90d": "90 days",
                custom: "Custom"
              },
              trend: {
                vsPrev: "vs previous period"
              },
              role: {
                admin: "Admin",
                supervisor: "Supervisor",
                agent: "Agent"
              },
              filter: {
                label: "Filters",
                title: "Filter data",
                queue: "Queue",
                whatsapp: "WhatsApp Account",
                agent: "Agent",
                all: "All",
                clear: "Clear filters",
                from: "From",
                to: "To"
              },
              breadcrumb: {
                home: "Home",
                dashboard: "Dashboard"
              },
              pulse: {
                systemStable: "System stable",
                activeChats: "active chats",
                onlineAgents: "agents online",
                activeNow: "live conversations"
              },
              kpi: {
                newMessages: "New messages",
                open: "Open",
                pending: "Pending",
                inProgress: "In progress",
                closed: "Closed",
                newCustomers: "New customers",
                totalTickets: "Total tickets",
                uniqueCustomers: "Unique customers",
                messagesReceived: "Messages received"
              },
              panel: {
                messagesToday: "Messages today",
                messagesRange: "Messages in {{periodLabel}}",
                ticketsByStatus: "Tickets by status",
                ticketsByHour: "Tickets by hour",
                generalStats: "General statistics",
                agents: "Agents",
                sections: "Tickets by custom tab",
                sectionsSub: "Distribution across your custom tag-filter tabs",
                inPeriod: "in the selected period"
              },
              donut: {
                total: "Tickets total"
              },
              metric: {
                avgHandle: "Avg handle time",
                avgWait: "Avg response time",
                totalTickets: "Total tickets",
                uniqueTickets: "Unique tickets",
                messagesSent: "Messages sent"
              },
              agents: {
                empty: "No agent data to show"
              },
              unit: {
                messages: "messages",
                tickets: "tickets"
              }
            },
            connections: {
              title: "Connections",
              connected: "Connected",
              hub: {
                statusBadge: {
                  connected: "Connected",
                  pending: "Connecting",
                  disconnected: "Not connected",
                  loading: "Loading…"
                },
                instagramNative: {
                  title: "Instagram",
                  description: "Connect your Instagram account directly — no Facebook Page required.",
                  connect: "Connect Instagram",
                  reconnect: "Reconnect",
                  disconnect: "Disconnect",
                  connected: "Instagram connected!",
                  connectedSub: "Connected directly",
                  idleSub: "Connect with Instagram Business Login",
                  expiredSub: "Session expired — reconnect"
                }
              },
              toasts: {
                deleted: "WhatsApp connection successfully deleted!"
              },
              confirmationModal: {
                deleteTitle: "Delete",
                deleteMessage: "Are you sure? This action cannot be undone.",
                disconnectTitle: "Disconnect",
                disconnectMessage: "Are you sure? You will need to scan the QR Code again."
              },
              buttons: {
                add: "Add WhatsApp",
                disconnect: "Disconnect",
                tryAgain: "Try Again",
                qrcode: "QR CODE",
                newQr: "New QR CODE",
                connecting: "Connecting"
              },
              toolTips: {
                disconnected: {
                  title: "Failed to initiate WhatsApp session",
                  content: "Make sure your phone is connected to the internet and try again, or request a new QR Code."
                },
                qrcode: {
                  title: "Waiting for QR Code scan",
                  content: "Click the 'QR CODE' button and scan the QR Code with your phone to start the session."
                },
                connected: {
                  title: "Connection established!"
                },
                timeout: {
                  title: "Connection to the phone has been lost",
                  content: "Make sure your phone is connected to the internet and WhatsApp is open, or click 'Disconnect' to get a new QR Code."
                }
              },
              table: {
                name: "Name",
                status: "Status",
                lastUpdate: "Last Update",
                default: "Default",
                actions: "Actions",
                session: "Session"
              }
            },
            rankings: {
              title: "Rankings",
              eyebrow: "Team",
              topSeller: "🔥 Top Seller of the Month:",
              topPerformer: "Top Performer",
              salesLabel: "Sales",
              table: "Sales Table",
              period: "Period",
              totalSales: "Total Sales",
              rank: "#",
              name: "Name",
              sales: "Sales",
              actions: "Actions",
              stats: {
                agents: "Agents"
              },
              empty: {
                title: "No sales recorded yet",
                adminHelp: "Sales is a manual counter — open Users and edit each agent to set their sales total.",
                userHelp: "Once your admin records sales for the team, the leaderboard will appear here.",
                editUsersBtn: "Open Users"
              }
            },
            appointments: {
              title: "Appointments",
              eyebrow: "Scheduling",
              heroSubtitleAdmin: "Manage how the WhatsApp bot books, and what lands in your calendar.",
              heroSubtitleOperator: "View bookings the WhatsApp bot has created.",
              common: {
                cancel: "Cancel",
                back: "Back"
              },
              when: {
                today: "Today",
                tomorrow: "Tomorrow"
              },
              summary: {
                allWeek: "All week"
              },
              connect: {
                title: "Connect a calendar",
                subtitle: "The AI bot reads free slots from the connected calendar and creates events when customers book through WhatsApp.",
                notConnectedTag: "No calendar connected",
                googleBtn: "Connect Google Calendar",
                microsoftBtn: "Connect Outlook",
                statusConnected: "Connected",
                lastSynced: "Last sync",
                disconnectBtn: "Disconnect",
                confirmDisconnectTitle: "Disconnect calendar?",
                confirmDisconnectBody: "The bot will stop proposing slots and creating events until a calendar is reconnected. Existing bookings stay.",
                disconnectedToast: "Calendar disconnected"
              },
              workingHours: {
                eyebrow: "Configuration",
                title: "Working hours",
                subtitle: "Days and times the bot may propose.",
                daysLabel: "Days the bot can propose",
                days: {
                  0: "Sun",
                  1: "Mon",
                  2: "Tue",
                  3: "Wed",
                  4: "Thu",
                  5: "Fri",
                  6: "Sat"
                },
                startLabel: "Start",
                endLabel: "End",
                saveBtn: "Save settings",
                savingBtn: "Saving...",
                savedToast: "Settings saved"
              },
              slotConfig: {
                durationLabel: "Slot duration",
                bufferLabel: "Buffer between slots"
              },
              bookings: {
                eyebrow: "Activity",
                title: "Bookings",
                upcomingLabel: "upcoming",
                totalLabel: "total",
                emptyTitle: "No bookings yet",
                emptyBody: "They'll appear here automatically as soon as a customer books through the WhatsApp bot.",
                cols: {
                  customer: "Customer",
                  phone: "Phone",
                  scheduledAt: "When",
                  status: "Status",
                  type: "Type",
                  location: "Location",
                  actions: ""
                },
                statuses: {
                  pending: "Pending",
                  confirmed: "Confirmed",
                  reminderSent: "Reminder sent",
                  completed: "Completed",
                  cancelled: "Cancelled"
                },
                cancelBtn: "Cancel booking",
                confirmCancelTitle: "Cancel this booking?",
                confirmCancelBody: "The calendar event will be removed and the customer will be notified.",
                confirmCancelBtn: "Cancel booking",
                cancelledToast: "Booking cancelled"
              },
              errors: {
                connectFailed: "Could not open the calendar provider's consent screen."
              },
              botConfig: {
                eyebrow: "Bot & reminders",
                title: "AI bot and reminders",
                subtitle: "How the WhatsApp bot replies and when reminders go out.",
                botEnabledLabel: "AI scheduling bot",
                botEnabledOn: "Enabled",
                botEnabledOff: "Disabled",
                languageLabel: "Bot reply language",
                reminderLeadLabel: "Reminder lead time",
                confirmationTimeoutLabel: "Confirmation timeout",
                templateNameLabel: "WhatsApp template name",
                templateNameHelp: "Must match a registered Meta template (e.g. whapiz_appointment_reminder).",
                signatureLabel: "Business signature",
                saveBtn: "Save bot settings",
                savingBtn: "Saving...",
                savedToast: "Bot settings saved",
                errors: {
                  templateNameRequired: "Template name is required — reminders will fail without it."
                }
              },
              oauth: {
                successTitle: "Calendar connected",
                successBody: "You're all set",
                providerGoogle: "Google Calendar",
                providerMicrosoft: "Microsoft Outlook",
                errorTitle: "Connection failed",
                errorBody: "Please try again"
              }
            },
            internalChat: {
              title: "Internal Chat",
              conversations: "Conversations",
              newChat: "New Chat",
              editChat: "Edit Chat",
              chatTitle: "Chat Title",
              chatTitlePlaceholder: "Enter chat title...",
              passwordOptional: "Password (Optional)",
              passwordPlaceholder: "Set password to protect chat",
              selectParticipants: "Select Participants",
              cancel: "Cancel",
              create: "Create",
              save: "Save",
              confirm: "Confirm",
              delete: "Delete",
              deleteChat: "Delete Chat",
              confirmDelete: "Are you sure you want to delete this chat?",
              chatCreated: "Chat created successfully",
              chatUpdated: "Chat updated successfully",
              chatDeleted: "Chat deleted successfully",
              error: "An error occurred",
              titleRequired: "Please enter a chat title",
              usersRequired: "Please select at least one participant",
              selectChat: "Select a conversation",
              selectChatDesc: "Choose a chat from the list to start messaging",
              emptyActions: {
                newChat: "New Chat",
                conversations: "Conversations",
                messages: "Messages"
              },
              noChats: "No conversations yet",
              noMessages: "No messages",
              startConversation: "Start a conversation",
              placeholder: "Type a message...",
              download: "Download",
              yesterday: "Yesterday",
              owner: "Owner",
              participants: "Participants",
              showOwner: "Show Owner",
              showUsers: "Show Participants",
              passwordRequired: "Password Required",
              password: "Password",
              incorrectPassword: "Incorrect password",
              passwordError: "Error verifying password",
              chats: "Chats",
              messages: "Messages",
              noChat: "No chat selected",
              addMember: "Add Member",
              add: "Add",
              memberAdded: "Member added successfully!",
              close: "Close",
              saving: "Adding...",
              changeColor: "Change Chat Color",
              eyebrow: "Team",
              stats: {
                conversations: "Conversations"
              }
            },
            whatsappModal: {
              title: {
                add: "Add WhatsApp",
                edit: "Edit WhatsApp"
              },
              form: {
                name: "Name",
                default: "Default",
                channel: "Channel",
                channelDescription: "Choose Baileys (QR login) or the official Meta Business API.",
                token: "Meta access token",
                tokenDescription: "Paste the permanent System User token provided by Meta.",
                defaultDisabled: "Only Baileys channels can be set as default.",
                channelLabelTitle: "Channel Label",
                channelLabelDescription: "Add a label to identify this number in chats (e.g., Website, Main, Support)",
                channelLabel: "Label",
                channelLabelColor: "Color"
              },
              channelOptions: {
                whatsapp: "WhatsApp Web (Baileys)",
                business: "Meta Business API"
              },
              buttons: {
                okAdd: "Add",
                okEdit: "Save",
                cancel: "Cancel"
              },
              success: "WhatsApp saved successfully."
            },
            qrCode: {
              message: "Scan the QR Code to start the session"
            },
            contacts: {
              title: "Contacts",
              whatsappUser: "WhatsApp user",
              toasts: {
                deleted: "Contact successfully deleted!"
              },
              searchPlaceholder: "Search...",
              confirmationModal: {
                deleteTitle: "Delete ",
                importTitlte: "Import Contacts",
                deleteMessage: "Are you sure you want to delete this contact? All related interactions will be lost.",
                importMessage: "Do you want to import all contacts from the phone?"
              },
              buttons: {
                import: "Import Contacts",
                add: "Add Contact"
              },
              table: {
                name: "Name",
                whatsapp: "WhatsApp",
                email: "Email",
                actions: "Actions",
                phone: "Phone"
              }
            },
            contactModal: {
              title: {
                add: "Add Contact",
                edit: "Edit Contact"
              },
              form: {
                mainInfo: "Contact Information",
                extraInfo: "Additional Information",
                name: "Name",
                number: "WhatsApp Number",
                email: "Email",
                extraName: "Field Name",
                extraValue: "Value",
                disableBot: "Disable chatbot"
              },
              buttons: {
                addExtraInfo: "Add Information",
                okAdd: "Add",
                okEdit: "Save",
                cancel: "Cancel"
              },
              success: "Contact saved successfully."
            },
            templates: {
              title: "WhatsApp Templates",
              syncButton: "Sync from Meta",
              syncFromMeta: "Sync from Meta",
              sync: "Sync",
              syncing: "Syncing...",
              noTemplates: "No templates found. Click 'Sync from Meta' to import templates.",
              syncNow: "Sync templates now",
              preview: "Preview",
              fillVariables: "Fill variables",
              lastSynced: "Last synced",
              description: "Templates are pre-approved messages that can be sent to customers after the 24-hour messaging window. Create templates in Meta Business Manager, then click 'Sync from Meta' to import them here.",
              connections: "WhatsApp Business Connections",
              errors: {
                fillAllVariables: "Please fill all variables",
                sendFailed: "Failed to send template",
                syncFailed: "Failed to sync templates"
              },
              success: {
                sent: "Template sent successfully",
                synced: "Templates synced successfully"
              },
              buttons: {
                send: "Send Template",
                cancel: "Cancel"
              },
              table: {
                name: "Name",
                language: "Language",
                connection: "Connection",
                status: "Status",
                category: "Category",
                active: "Active",
                preview: "Preview"
              },
              categories: {
                utility: "Utility",
                marketing: "Marketing",
                authentication: "Authentication"
              },
              active: "Active",
              inactive: "Inactive",
              refresh: "Refresh",
              stats: {
                total: "Total",
                approved: "Approved",
                pending: "Pending",
                rejected: "Rejected"
              }
            },
            gptMenu: {
              aiSuggestions: "AI Suggestions",
              conversationSummary: "Conversation Summary",
              salesOpportunities: "Sales Opportunities",
              sentimentAnalysis: "Sentiment Analysis",
              agentPerformance: "Agent Performance",
              keyIssues: "Key Issues"
            },
            gptSettings: {
              title: "GPT AI Assistant",
              subtitle: "AI-powered suggestions for your support team",
              enableTitle: "Enable GPT Assistant",
              enableDescription: "AI suggestions will appear in ticket conversations",
              status: "Status",
              apiKeyConfigured: "API Key configured",
              apiKeyMissing: "API Key missing",
              gptEnabled: "GPT is enabled",
              gptDisabled: "GPT is disabled",
              currentModel: "Current model",
              apiConfiguration: "API Configuration",
              aiModel: "AI Model",
              openaiApiKey: "OpenAI API Key",
              getApiKey: "Get your API key from platform.openai.com",
              recommended: "Recommended",
              responseTone: "Response Tone",
              responseToneDescription: "Choose how the AI should communicate",
              advancedSettings: "Advanced Settings",
              customPrompt: "Custom System Prompt",
              customPromptPlaceholder: "Add custom instructions for the AI...",
              customPromptHint: "This will be added to all AI responses",
              saveSettings: "Save Settings",
              saving: "Saving...",
              saved: "Settings saved.",
              loading: "Loading...",
              showAdvanced: "Show advanced",
              hideAdvanced: "Hide advanced",
              statusDesc: "Current connection state of the AI assistant",
              apiConfigDesc: "OpenAI API key and model selection",
              advancedDesc: "Custom system prompt and fine-tuning"
            },
            aiDashboard: {
              title: "AI Dashboard",
              refresh: "Refresh",
              noData: "No data available",
              allAgents: "All Agents",
              daysCount: "{{count}} days",
              singleDay: "day",
              multiDay: "days",
              kpi: {
                totalConversations: "Total Chats",
                open: "Open",
                pending: "Pending",
                closed: "Closed",
                responseTime: "Response Time",
                satisfaction: "Satisfaction",
                resolvedPct: "{{pct}}% resolved",
                outOfFive: "out of 5.0"
              },
              subtitle: {
                chats: "{{count}} chats",
                activeAgents: "{{count}} active agents"
              },
              quickInsights: {
                loadSubtitle: "{{score}}/100 load",
                resolutionSubtitle: "{{closed}} of {{total}}",
                avgPerTicket: "avg per ticket",
                noStats: "No data",
                customerSatisfaction: "Customer Satisfaction"
              },
              units: {
                minuteAbbr: "m",
                hourAbbr: "h",
                dayAbbr: "d"
              },
              tabs: {
                overview: "Overview",
                agentPerformance: "Agent Performance",
                keyIssues: "Key Issues",
                sentimentTrends: "Sentiment Trends",
                salesInsights: "Sales Insights",
                learning: "Learning"
              },
              filters: {
                dateRange: "Date Range",
                last7days: "Last 7 days",
                last14days: "Last 14 days",
                last30days: "Last 30 days",
                last90days: "Last 90 days"
              },
              overview: {
                totalConversations: "Total Conversations",
                avgResponseTime: "Avg Response Time",
                resolutionRate: "Resolution Rate",
                satisfaction: "Customer Satisfaction",
                aiPerformance: "AI Performance",
                suggestionsUsed: "AI Suggestions Used",
                aiAccuracy: "AI Accuracy",
                activeAgents: "Active Agents",
                pendingTickets: "Pending Tickets",
                quickInsights: "Quick Insights",
                workload: "Workload",
                openTickets: "Open Tickets",
                ticketsPerAgent: "Tickets per Agent",
                workloadLevel: "Workload Level",
                systemStatus: "System Status",
                closedToday: "Closed Today"
              },
              status: {
                normal: "Normal",
                moderate: "Moderate Load",
                highLoad: "High Load"
              },
              insights: {
                peakHours: "Peak Activity Hours",
                peakHoursDesc: "Most conversations occur between 10AM-2PM",
                topPerformer: "Top Performer",
                topPerformerDesc: "Based on response time and resolution rate"
              },
              agentPerformance: {
                selectAgent: "Select Agent",
                allAgents: "All Agents",
                responseTime: "Avg Response Time",
                ticketsHandled: "Tickets Handled",
                qualityScore: "Quality Score",
                detailedAnalysis: "Detailed Analysis",
                workload: "Workload",
                politenessScore: "Politeness Score",
                aiRecommendations: "AI Recommendations",
                firstResponse: "First Response",
                missedMessages: "Missed Messages",
                ticketsResolved: "Tickets Resolved",
                sentimentTrend: "Sentiment Trend",
                confusionCases: "Confusion Cases",
                recoveryRate: "Recovery Rate",
                resolutionRate: "Resolution Rate",
                improving: "Improving",
                declining: "Declining",
                stable: "Stable"
              },
              keyIssues: {
                title: "Detected Issues",
                subtitle: "Issues identified across customer conversations",
                occurrences: "occurrences",
                lastSeen: "Last seen",
                noIssues: "No critical issues detected",
                unknownIssue: "Unknown Issue",
                ticketsAffected: "tickets affected",
                patterns: "Common patterns",
                recommendations: "Recommendations"
              },
              sentiment: {
                positive: "Positive",
                neutral: "Neutral",
                negative: "Negative",
                trends: "Sentiment Trends",
                trendsDescription: "Track customer sentiment over time to identify patterns and improvements",
                trend: "Trend",
                messagesAnalyzed: "Messages Analyzed",
                topPositiveKeywords: "Top Positive Keywords",
                topNegativeKeywords: "Top Negative Keywords",
                improving: "Improving",
                declining: "Declining",
                stable: "Stable"
              },
              salesInsights: {
                title: "Sales Opportunities",
                upsellOpportunities: "Upsell Opportunities",
                upsellDescription: "Conversations with potential for additional sales",
                conversionRate: "Conversion Rate",
                conversionDescription: "Leads converted to successful bookings",
                totalOpportunities: "Total Opportunities",
                revenuePotential: "Revenue Potential",
                upsellCrossSell: "Upsell + Cross-sell",
                opportunitiesByType: "Opportunities by Type",
                upsell: "Upsell",
                crossSell: "Cross-sell",
                newProduct: "New Product",
                topProductsMentioned: "Top Products Mentioned",
                noProductsDetected: "No products detected",
                recentOpportunities: "Recent Opportunities"
              }
            },
            aiWorkforce: {
              title: "AI Workforce",
              refresh: "Refresh",
              enabled: "Active",
              disabled: "Disabled",
              stats: {
                activeAgents: "Active Agents",
                knowledgeItems: "Knowledge Items",
                businessRules: "Business Rules",
                actionsToday: "Actions Today"
              },
              tabs: {
                agents: "AI Agents",
                knowledge: "Knowledge Base",
                rules: "Business Rules",
                logs: "Action Logs",
                pipeline: "Pipeline"
              },
              pipeline: {
                enableCustom: "Enable Custom AI Pipeline",
                enableDesc: "When enabled, the company uses a custom AI pipeline instead of the default.",
                dataSource: "Data Source",
                dataSourceType: "Type",
                dataSourceNone: "None",
                testConnection: "Test Connection",
                connected: "Connected",
                connectionFailed: "Connection failed",
                pipelineSteps: "Pipeline Steps",
                pipelineStepsDesc: "Define the order of AI processing steps. Each step enriches the context for the next.",
                aiTools: "AI Tools",
                addTool: "Add Tool",
                aiToolsDesc: "Define which data the AI can query from your data source.",
                noTools: "No tools configured. Add a tool to enable data queries for the AI.",
                table: "Table",
                filter: "Filter",
                fields: "Fields",
                systemPrompt: "System Prompt",
                systemPromptPlaceholder: "Describe your business and how the AI should assist customers. For example: 'You are a virtual assistant for a property management company. Help tenants with payment inquiries, maintenance requests, and general questions.'",
                saving: "Saving...",
                saveSettings: "Save Pipeline Settings",
                saved: "Pipeline settings saved",
                steps: {
                  dataFetcher: "Data Fetcher",
                  dataFetcherDesc: "Query from external data source",
                  conversation: "Conversation",
                  conversationDesc: "Generate AI response",
                  supervisor: "Supervisor",
                  supervisorDesc: "Quality check before sending"
                },
                toolDialog: {
                  addTitle: "Add Tool",
                  editTitle: "Edit Tool",
                  toolName: "Tool Name",
                  description: "Description",
                  tableEndpoint: "Table / Endpoint",
                  filterField: "Filter Field (optional)",
                  fieldsComma: "Fields (comma separated, optional)",
                  cancel: "Cancel",
                  add: "Add",
                  update: "Update"
                }
              },
              agents: {
                title: "AI Agents Configuration",
                addAgent: "Add Agent",
                createTitle: "Create Agent",
                editTitle: "Edit Agent",
                name: "Agent Name",
                role: "Role",
                model: "GPT Model",
                temperature: "Temperature",
                maxTokens: "Max Tokens",
                systemPrompt: "System Prompt (Optional)",
                agentEnabled: "Agent Enabled",
                test: "Test",
                testAgent: "Test Agent",
                runningTest: "Running test...",
                testSuccess: "Test completed successfully",
                result: "Result",
                noAgents: "No AI Agents Yet",
                noAgentsDesc: "Create your first AI agent to automate workflows",
                deleteConfirm: "Are you sure you want to delete this agent?",
                created: "Agent created successfully",
                updated: "Agent updated successfully",
                deleted: "Agent deleted",
                roles: {
                  conversation: "Conversation Agent",
                  queue_manager: "Queue Manager",
                  process_finisher: "Process Finisher",
                  offer_matcher: "Offer Matcher",
                  pricing_calculator: "Pricing Calculator",
                  promotion_engine: "Promotion Engine",
                  supervisor: "Supervisor Agent",
                  business_intelligence: "Business Intelligence",
                  scheduling_manager: "Scheduling Manager",
                  notification_engine: "Notification Engine"
                },
                models: {
                  gpt4o: "GPT-4o (Recommended)",
                  gpt4turbo: "GPT-4 Turbo",
                  gpt35turbo: "GPT-3.5 Turbo (Faster)"
                },
                temperatureLabels: {
                  precise: "Precise",
                  creative: "Creative"
                }
              },
              knowledge: {
                title: "Knowledge Base",
                add: "Add",
                createTitle: "Add Knowledge",
                editTitle: "Edit Knowledge",
                titleField: "Title",
                content: "Content",
                type: "Type",
                active: "Active",
                inactive: "Inactive",
                updated: "Updated",
                search: "Search...",
                noKnowledge: "No Knowledge Entries",
                noKnowledgeDesc: "Add products, FAQs, and policies for AI to reference",
                deleteConfirm: "Delete this knowledge entry?",
                created: "Knowledge created",
                updatedMsg: "Knowledge updated",
                deleted: "Knowledge deleted",
                types: {
                  product: "Product",
                  faq: "FAQ",
                  policy: "Policy",
                  general: "General",
                  supplier: "Supplier",
                  destination: "Destination"
                }
              },
              rules: {
                title: "Business Rules",
                addRule: "Add Rule",
                createTitle: "Add Rule",
                editTitle: "Edit Rule",
                name: "Rule Name",
                type: "Type",
                description: "Description",
                priority: "Priority",
                conditions: "Conditions (JSON)",
                actions: "Actions (JSON)",
                active: "Active",
                inactive: "Inactive",
                noRules: "No Business Rules",
                noRulesDesc: "Configure pricing, routing, and escalation rules",
                deleteConfirm: "Delete this rule?",
                created: "Rule created",
                updated: "Rule updated",
                deleted: "Rule deleted",
                types: {
                  pricing: "Pricing",
                  promotion: "Promotion",
                  routing: "Routing",
                  escalation: "Escalation",
                  commission: "Commission",
                  general: "General"
                },
                keywordsHelper: "e.g. cancel, stop, manager"
              },
              logs: {
                title: "AI Action Logs",
                noLogs: "No Logs Yet",
                noLogsDesc: "AI actions will appear here",
                ticket: "Ticket"
              },
              common: {
                save: "Save",
                cancel: "Cancel",
                close: "Close",
                all: "All",
                name: "Name",
                status: "Status",
                actions: "Actions",
                edit: "Edit",
                delete: "Delete"
              }
            },
            offers: {
              title: "Offers Catalog",
              newOffer: "New Offer",
              searchPlaceholder: "Search offers...",
              stats: {
                total: "Total Offers",
                active: "Active",
                featured: "Featured"
              },
              source: {
                label: "Source",
                all: "All Sources",
                internal: "Internal",
                external: "Raviv API",
                offerDetails: "Offer Details"
              },
              table: {
                offer: "Offer",
                destination: "Destination",
                duration: "Duration",
                price: "Price",
                status: "Status",
                featured: "Featured",
                actions: "Actions",
                nights: "nights",
                active: "Active",
                inactive: "Inactive"
              },
              modal: {
                createTitle: "Create New Offer",
                editTitle: "Edit Offer",
                sections: {
                  basicInfo: "Basic Information",
                  destination: "Destination",
                  datesDuration: "Dates & Duration",
                  pricing: "Pricing",
                  accommodation: "Accommodation",
                  flight: "Flight (optional)",
                  images: "Images",
                  status: "Status"
                },
                fields: {
                  title: "Offer Title",
                  titlePlaceholder: "e.g., Romantic Paris Getaway",
                  type: "Type",
                  description: "Description",
                  descriptionPlaceholder: "Describe what makes this offer special...",
                  destination: "Destination",
                  destinationPlaceholder: "e.g., Paris",
                  country: "Country",
                  countryPlaceholder: "e.g., France",
                  validFrom: "Valid From",
                  validTo: "Valid To",
                  days: "Days",
                  nights: "Nights",
                  basePrice: "Base Price",
                  currency: "Currency",
                  childPrice: "Child Price",
                  markup: "Markup %",
                  hotelName: "Hotel Name",
                  stars: "Stars",
                  board: "Board",
                  airline: "Airline",
                  departureCity: "Departure City",
                  compositionPricing: "Composition Pricing (Total per group)",
                  compositionPricingHint: "Set total package prices for each family composition. Leave empty to use base price × travelers.",
                  pricingCouple: "Couple",
                  pricingCouple1Child: "Couple + 1 Child",
                  pricingCouple2Children: "Couple + 2 Children",
                  pricingCouple3Children: "Couple + 3 Children",
                  pricingSingle: "Single",
                  pricing3Adults: "3 Adults",
                  pricing3Adults1Child: "3 Adults + 1 Child",
                  pricing3Adults2Children: "3 Adults + 2 Children"
                },
                boardTypes: {
                  none: "None",
                  roomOnly: "Room Only",
                  bedBreakfast: "Bed & Breakfast",
                  halfBoard: "Half Board",
                  fullBoard: "Full Board",
                  allInclusive: "All Inclusive"
                },
                types: {
                  package: "Package",
                  flight: "Flight",
                  hotel: "Hotel",
                  tour: "Tour",
                  cruise: "Cruise",
                  custom: "Custom"
                },
                active: "Active",
                activeDescription: "Visible to customers",
                featured: "Featured",
                featuredDescription: "Highlighted in listings",
                cancel: "Cancel",
                create: "Create Offer",
                save: "Save Changes"
              },
              images: {
                title: "Add images to showcase this offer",
                hint: "High quality images increase booking rates by 40%",
                uploadNew: "Upload New",
                browseLibrary: "Browse Library",
                uploading: "Uploading images..."
              },
              mediaBrowser: {
                title: "Select from Media Library",
                selected: "image(s) selected",
                clickToSelect: "Click images to select them",
                loading: "Loading your media files...",
                noFiles: "No media files found",
                noFilesHint: "Upload some images first to see them here",
                cancel: "Cancel",
                addImages: "Add"
              },
              empty: {
                title: "No offers yet",
                description: "Create your first offer to start attracting customers",
                createFirst: "Create First Offer"
              },
              delete: {
                title: "Delete Offer",
                confirm: "Are you sure you want to delete",
                warning: "This action cannot be undone."
              },
              toast: {
                created: "Offer created successfully!",
                updated: "Offer updated successfully!",
                deleted: "Offer deleted"
              },
              pagination: {
                showing: "Showing",
                of: "of"
              }
            },
            queueModal: {
              title: {
                add: "Add Queue",
                edit: "Edit Queue"
              },
              form: {
                name: "Name",
                color: "Color",
                greetingMessage: "Greeting Message",
                complationMessage: "Completion Message",
                outOfHoursMessage: "Out of Hours Message",
                ratingMessage: "Rating Message",
                transferMessage: "Transfer Message",
                token: "Token",
                menuType: "Menu Type"
              },
              menuTypes: {
                auto: "Auto (Smart Detection)",
                buttons: "Quick Reply Buttons",
                list: "List Menu",
                text: "Text (Classic 1-2-3)"
              },
              buttons: {
                okAdd: "Add",
                okEdit: "Save",
                cancel: "Cancel",
                attach: "Attach File",
                edit: "Edit",
                duplicate: "Duplicate"
              },
              serviceHours: {
                dayWeek: "Day of the week",
                startTimeA: "Start Time - Shift A",
                endTimeA: "End Time - Shift A",
                startTimeB: "Start Time - Shift B",
                endTimeB: "End Time - Shift B",
                monday: "Monday",
                tuesday: "Tuesday",
                wednesday: "Wednesday",
                thursday: "Thursday",
                friday: "Friday",
                saturday: "Saturday",
                sunday: "Sunday"
              },
              options: {
                title: "Options",
                notDefined: "Title not defined",
                message: "Enter the option text",
                note: {
                  title: "Add options to build a chatbot",
                  content: "If there is only one option, it will be selected automatically, triggering the bot to respond with the option message and continue"
                },
                addOpts: "Add Options",
                attendant: "Transfer to:"
              },
              confirmationModal: {
                deleteTitle: "Delete Attachment",
                deleteMessage: "Are you sure you want to delete this attachment?",
                deleteOptionTitle: "Delete Bot Question",
                deleteOptionMessage: "Are you sure you want to delete this bot question? This action cannot be undone."
              }
            },
            userModal: {
              title: {
                add: "Add User",
                edit: "Edit User"
              },
              form: {
                name: "Name",
                email: "Email",
                password: "Password",
                profile: "Profile",
                sales: "Sales",
                salesHelp: "Manual counter shown on the Rankings leaderboard.",
                currency: "Currency"
              },
              buttons: {
                okAdd: "Add",
                okEdit: "Save",
                save: "Save",
                cancel: "Cancel"
              },
              success: "User saved successfully."
            },
            scheduleModal: {
              title: {
                add: "New Schedule",
                edit: "Edit Schedule",
                error: "Send Error",
                message: "Message"
              },
              form: {
                body: "Message",
                contact: "Contact",
                sendAt: "Scheduled Date",
                sentAt: "Sent Date",
                saveMessage: "Save Message in Ticket"
              },
              buttons: {
                okAdd: "Add",
                okEdit: "Save",
                cancel: "Cancel"
              },
              success: "Schedule saved successfully."
            },
            tagModal: {
              title: {
                add: "New Tag",
                edit: "Edit Tag",
                addKanban: "New Lane",
                editKanban: "Edit Lane"
              },
              form: {
                name: "Name",
                color: "Color",
                kanban: "Kanban"
              },
              buttons: {
                okAdd: "Add",
                okEdit: "Save",
                cancel: "Cancel"
              },
              success: "Tag saved successfully.",
              successKanban: "Lane saved successfully."
            },
            chat: {
              noTicketMessage: "Select a ticket to start the conversation.",
              selectTicket: "Select Ticket",
              title: "Chat",
              welcomeBack: "Welcome back",
              tip1Title: "Pick a conversation",
              tip1Text: "Click any chat in the list to start replying to a customer",
              tip2Title: "Quick replies",
              tip2Text: "Use ready-made quick replies to save time on every conversation",
              tip3Title: "Be first to respond",
              tip3Text: "A reply within 7 minutes raises customer satisfaction by 32%"
            },
            uploads: {
              titles: {
                titleUploadMsgDragDrop: "DRAG AND DROP FILES IN THE FIELD BELOW",
                titleFileList: "List of file(s)"
              }
            },
            ticketsManager: {
              buttons: {
                newTicket: "New"
              }
            },
            ticketsQueueSelect: {
              placeholder: "Queues"
            },
            tickets: {
              title: "Chat Tickets",
              toasts: {
                deleted: "The ticket you were working on has been deleted."
              },
              notification: {
                message: "Message from"
              },
              tabs: {
                open: {
                  title: "Open"
                },
                closed: {
                  title: "Closed"
                },
                groups: {
                  title: "Groups"
                },
                search: {
                  title: "Search"
                }
              },
              search: {
                placeholder: "Search by name, phone or message text..."
              },
              buttons: {
                showAll: "All"
              }
            },
            ticketsList: {
              pendingHeader: "Pending",
              assignedHeader: "In Progress",
              noTicketsTitle: "Nothing here!",
              noTicketsMessage: "No tickets found with this status or search term",
              noQueue: "No Queue",
              buttons: {
                accept: "Accept",
                close: "Close"
              },
              items: {
                tags: "Tags"
              }
            },
            transferTicketModal: {
              title: "Transfer Ticket",
              fieldLabel: "Type to search for users",
              fieldQueueLabel: "Transfer to queue",
              fieldQueuePlaceholder: "Select a queue",
              noOptions: "No user found with that name",
              buttons: {
                ok: "Transfer",
                cancel: "Cancel"
              }
            },
            forwardMessageModal: {
              dialog: {
                title: "Forward message to:",
                button: "Send",
                sending: "Sending",
                error: "Please select messages to forward"
              }
            },
            newTicketModal: {
              title: "Create Ticket",
              fieldLabel: "Type to search for contact",
              add: "Add",
              buttons: {
                ok: "Save",
                cancel: "Cancel"
              }
            },
            moveTicket: {
              button: "Move to…",
              current: "current",
              status: {
                open: "Open",
                pending: "Pending",
                closed: "Closed"
              }
            },
            mainDrawer: {
              search: "Search menu…",
              listItems: {
                aiOs: "AI-OS — the Brain",
                dashboard: "Dashboard",
                connections: "Connections",
                tickets: "Tickets",
                appointments: "Appointments",
                quickMessages: "Quick Responses",
                contacts: "Contacts",
                queues: "Queues & Chatbot",
                tags: "Tags",
                toDoList: "To-Do List",
                administration: "Administration",
                service: "Service",
                users: "Users",
                settings: "Settings",
                helps: "Help",
                about: "Sales Leaders",
                messagesAPI: "API",
                schedules: "Scheduled Tasks",
                files: "Files",
                campaigns: "Campaigns",
                annoucements: "Announcements",
                chats: "Internal Chat",
                financeiro: "Financial",
                logout: "Logout",
                management: "Management",
                kanban: "Kanban",
                whatsappBackups: "WhatsApp Backups",
                archive: "Archive",
                aiDashboard: "AI Dashboard",
                aiSettings: "AI Settings",
                voiceSettings: "Voice",
                voiceIntelligence: "Voice Intelligence",
                aiWorkforce: "AI Workforce",
                teams: "Teams",
                offers: "Offers Catalog",
                pipelines: "Pipelines",
                billing: "Billing"
              },
              role: {
                administrator: "Administrator",
                supervisor: "Supervisor",
                agent: "Agent"
              },
              workspace: {
                admin: "Admin workspace",
                supervisor: "Supervisor workspace",
                default: "Workspace"
              },
              appBar: {
                backToAdmin: "Back to admin",
                i18n: {
                  language: "English",
                  language_short: "EN"
                },
                greetings: {
                  one: "Hello",
                  two: "Welcome to"
                },
                user: {
                  profile: "Profile",
                  darkmode: "Dark mode",
                  lightmode: "Light mode",
                  language: "Select language",
                  logout: "Logout"
                },
                notRegister: "No internal chats"
              }
            },
            messagesAPI: {
              title: "API",
              textMessage: {
                number: "Number",
                body: "Message",
                token: "Registered Token"
              },
              mediaMessage: {
                number: "Number",
                body: "File Name",
                media: "File",
                token: "Registered Token"
              }
            },
            notifications: {
              noTickets: "No notifications."
            },
            quickMessages: {
              title: "Quick Responses",
              table: {
                shortcut: "Shortcut",
                message: "Message",
                actions: "Actions"
              },
              buttons: {
                add: "New Response",
                save: "Save"
              },
              dialog: {
                shortcode: "Shortcut",
                message: "Response"
              },
              toasts: {
                deleted: "Quick response deleted successfully."
              },
              empty: {
                title: "No quick responses yet",
                desc: "Build ready-made replies you can send with one tap when answering customers. Saves time on every conversation and keeps the voice consistent across your team.",
                cta: "Create your first quick response"
              },
              samples: {
                welcome: "Hi! Welcome to GoDeal. I'm here to help — how can I assist you today? 👋",
                hours: "Our hours: Sun–Thu 09:00–18:00, Fri 09:00–13:00.",
                thanks: "Thanks for reaching out! I'll get back to you shortly with a proper answer. 🙏"
              }
            },
            toDoList: {
              confirmDelete: "Delete \"{{title}}\"? This cannot be undone.",
              title: "Task Management",
              tasksCompleted: "tasks completed",
              reminder: "Reminder",
              dueIn: "due in",
              hours: "hours",
              reminderEnabled: "Reminder enabled",
              stats: {
                total: "Total",
                active: "Active",
                completed: "Done",
                overdue: "Overdue"
              },
              tabs: {
                all: "All",
                active: "Active",
                completed: "Completed",
                overdue: "Overdue"
              },
              filters: {
                allPriorities: "All Priorities",
                allTypes: "All Types"
              },
              sort: {
                newest: "Newest First",
                priority: "By Priority",
                dueDate: "By Due Date",
                title: "By Title"
              },
              priority: {
                high: "High",
                medium: "Medium",
                low: "Low",
                urgent: "Urgent"
              },
              dates: {
                today: "Today",
                tomorrow: "Tomorrow"
              },
              form: {
                label: "Create new task",
                placeholder: "Enter task",
                title: "Title",
                description: "Description",
                priority: "Priority",
                dueDate: "Due Date",
                reminderOn: "🔔 Reminder ON (24h before)",
                reminderOff: "🔕 Enable Reminder",
                category: "Category",
                noCategory: "No Category",
                reminderDate: "Reminder Date",
                visibility: "Visibility",
                assignTo: "Assign To",
                myself: "Myself",
                team: "Team",
                selectTeam: "Select Team",
                queue: "Queue",
                selectQueue: "Select Queue",
                shareWith: "Share With",
                selectUsers: "Select Users"
              },
              table: {
                task: "Task",
                date: "Created Date",
                actions: "Actions"
              },
              buttons: {
                add: "Add Task",
                save: "Save",
                cancel: "Cancel",
                newTask: "New Task",
                createFirst: "Create Your First Task"
              },
              dialog: {
                newTask: "New Task",
                editTask: "Edit Task"
              },
              actions: {
                markComplete: "Mark as Complete",
                markIncomplete: "Mark as Incomplete",
                edit: "Edit",
                delete: "Delete",
                refresh: "Refresh",
                complete: "Mark Complete",
                reopen: "Reopen"
              },
              messages: {
                created: "Task created successfully",
                updated: "Task updated successfully",
                deleted: "Task deleted",
                completed: "Completed!"
              },
              errors: {
                titleRequired: "Task title is required",
                loadFailed: "Failed to load tasks",
                saveFailed: "Failed to save task",
                updateFailed: "Failed to update task",
                deleteFailed: "Failed to delete task"
              },
              empty: {
                noTasks: "No tasks yet. Create your first one!",
                noCompleted: "No completed tasks yet",
                noOverdue: "Great! No overdue tasks"
              },
              status: {
                pending: "Pending",
                in_progress: "In Progress",
                completed: "Completed",
                cancelled: "Cancelled"
              },
              visibility: {
                personal: "Personal",
                personalDesc: "Only you can see",
                shared: "Shared",
                sharedDesc: "Share with selected users",
                team: "Team",
                teamDesc: "All team members can see",
                queue: "Queue",
                queueDesc: "All users in queue can see"
              },
              noAssignee: "Unassigned",
              notifications: {
                newTaskAssigned: "New task assigned to you"
              },
              comments: {
                title: "Comments",
                noComments: "No comments yet",
                placeholder: "Write a comment...",
                added: "Comment added",
                deleted: "Comment deleted",
                addFailed: "Failed to add comment",
                deleteFailed: "Failed to delete comment",
                delete: "Delete comment",
                unknownUser: "Unknown user"
              }
            },
            kanban: {
              title: "Kanban",
              searchPlaceholder: "Search",
              subMenus: {
                list: "Panel",
                tags: "Lanes"
              }
            },
            tagsKanban: {
              title: "Lanes",
              laneDefault: "Open",
              confirmationModal: {
                deleteTitle: "Are you sure you want to delete this Lane?",
                deleteMessage: "This action cannot be undone."
              },
              table: {
                name: "Name",
                color: "Color",
                tickets: "Tickets",
                actions: "Actions"
              },
              buttons: {
                add: "New Lane"
              },
              toasts: {
                deleted: "Lane deleted successfully."
              }
            },
            contactLists: {
              title: "Contact Lists",
              table: {
                name: "Name",
                contacts: "Contacts",
                actions: "Actions"
              },
              buttons: {
                add: "New List"
              },
              dialog: {
                name: "Name",
                company: "Company",
                okEdit: "Edit",
                okAdd: "Add",
                add: "Add",
                edit: "Edit",
                cancel: "Cancel"
              },
              confirmationModal: {
                deleteTitle: "Delete",
                deleteMessage: "This action cannot be undone."
              },
              toasts: {
                deleted: "Record deleted",
                created: "Record created"
              }
            },
            files: {
              title: "Files Catalog",
              preview: "File Preview",
              notImage: "This file is not an image",
              download: "Download File",
              table: {
                name: "Name",
                contacts: "Contacts",
                actions: "Actions",
                view: "View File"
              },
              toasts: {
                deleted: "File deleted successfully!",
                deletedAll: "All files deleted successfully!"
              },
              buttons: {
                add: "Add",
                deleteAll: "Delete All"
              },
              confirmationModal: {
                deleteTitle: "Delete",
                deleteAllTitle: "Delete All",
                deleteMessage: "Are you sure you want to delete this file?",
                deleteAllMessage: "Are you sure you want to delete all files?"
              },
              empty: {
                title: "No file lists yet",
                desc: "Build pre-loaded file lists and send them to customers with one click — perfect for catalogs, decks and marketing assets."
              }
            },
            fileModal: {
              title: {
                add: "Add Catalog Entry",
                edit: "Edit Catalog Entry"
              },
              form: {
                name: "Item name",
                message: "Item description",
                fileOptions: "Attachments",
                extraName: "Additional details"
              },
              buttons: {
                okAdd: "Save",
                okEdit: "Update",
                cancel: "Cancel",
                fileOptions: "Add attachment"
              },
              success: "Catalog entry saved successfully."
            },
            contactListItems: {
              title: "Contacts",
              searchPlaceholder: "Search",
              buttons: {
                add: "New",
                lists: "Lists",
                import: "Import"
              },
              dialog: {
                name: "Name",
                number: "Number",
                whatsapp: "WhatsApp",
                email: "Email",
                okEdit: "Edit",
                okAdd: "Add",
                add: "Add",
                edit: "Edit",
                cancel: "Cancel"
              },
              table: {
                name: "Name",
                number: "Number",
                whatsapp: "WhatsApp",
                email: "Email",
                actions: "Actions"
              },
              confirmationModal: {
                deleteTitle: "Delete",
                deleteMessage: "This action cannot be undone.",
                importMessage: "Do you want to import the contacts from this spreadsheet? ",
                importTitlte: "Import"
              },
              toasts: {
                deleted: "Record deleted"
              }
            },
            campaigns: {
              title: "WhatsApp Campaigns",
              searchPlaceholder: "Search campaigns...",
              buttons: {
                add: "New Campaign",
                addRecipients: "Add Recipients",
                send: "Send Campaign",
                edit: "Edit",
                delete: "Delete",
                viewStats: "View Stats",
                refresh: "Refresh",
                contactLists: "Contact Lists",
                pause: "Pause",
                resume: "Resume",
                stop: "Stop",
                restart: "Restart"
              },
              table: {
                name: "Name",
                type: "Type",
                template: "Template",
                whatsapp: "Connection",
                contactList: "Contact List",
                status: "Status",
                recipients: "Recipients",
                progress: "Progress",
                scheduledAt: "Scheduled",
                completedAt: "Completed",
                createdAt: "Created",
                confirmation: "Confirmation",
                actions: "Actions",
                sentAt: "Sent At"
              },
              status: {
                draft: "Draft",
                scheduled: "Scheduled",
                sending: "Sending",
                paused: "Paused",
                completed: "Completed",
                cancelled: "Cancelled",
                failed: "Failed"
              },
              types: {
                marketing: "Marketing",
                service_update: "Service Update"
              },
              dialog: {
                new: "Create New Campaign",
                update: "Edit Campaign",
                readonly: "Read-only",
                form: {
                  name: "Campaign Name",
                  type: "Type",
                  template: "Template",
                  language: "Language",
                  whatsapp: "WhatsApp Connection",
                  scheduledAt: "Schedule Send (optional)",
                  scheduledAtHint: "Leave empty to send manually",
                  templateParams: "Template Parameters",
                  paramPlaceholder: "Value for this parameter",
                  message1: "Message 1",
                  message2: "Message 2",
                  message3: "Message 3",
                  message4: "Message 4",
                  message5: "Message 5",
                  confirmationMessage1: "Confirmation Message 1",
                  confirmationMessage2: "Confirmation Message 2",
                  confirmationMessage3: "Confirmation Message 3",
                  confirmationMessage4: "Confirmation Message 4",
                  confirmationMessage5: "Confirmation Message 5",
                  messagePlaceholder: "Message content",
                  status: "Status",
                  confirmation: "Confirmation",
                  contactList: "Contact List"
                },
                buttons: {
                  add: "Create",
                  edit: "Save",
                  okadd: "Ok",
                  cancel: "Cancel",
                  restart: "Restart Dispatches",
                  close: "Close",
                  attach: "Attach File",
                  import: "Import"
                }
              },
              recipients: {
                title: "Add Recipients",
                tabs: {
                  csv: "CSV Upload",
                  manual: "Manual Entry",
                  contacts: "From Contacts"
                },
                csv: {
                  description: "Upload a CSV file with columns: phone, name (optional), var1, var2, var3 (for template variables)",
                  upload: "Click to upload CSV file",
                  preview: "Preview",
                  rows: "rows",
                  moreRows: "and {{count}} more rows",
                  variables: "Variables"
                },
                manual: {
                  description: "Enter phone numbers (one per line, or separated by commas). Numbers should be in international format (e.g., 972501234567).",
                  placeholder: "972501234567\n972502345678\n972503456789",
                  numbersEntered: "{{count}} numbers entered"
                },
                contacts: {
                  search: "Search contacts...",
                  selectAll: "Select All",
                  selected: "{{count}} selected",
                  noContacts: "No contacts found"
                },
                importResult: {
                  title: "Import completed:",
                  imported: "Imported",
                  duplicates: "Duplicates",
                  invalid: "Invalid",
                  matched: "Matched contacts",
                  filtered: "Filtered (no history)"
                },
                safetyFilter: {
                  label: "Safety Filter: Only contacts with chat history",
                  description: "Protects against Meta blocking messages to contacts who never interacted with your business"
                }
              },
              details: {
                stats: {
                  total: "Total",
                  pending: "Pending",
                  sent: "Sent",
                  delivered: "Delivered",
                  read: "Read",
                  failed: "Failed"
                },
                info: {
                  template: "Template",
                  language: "Language",
                  whatsapp: "WhatsApp",
                  created: "Created"
                },
                tabs: {
                  all: "All Recipients",
                  failed: "Failed"
                },
                noRecipients: "No recipients yet. Import from CSV to add recipients.",
                error: "Error",
                cost: {
                  title: "Cost Estimation",
                  perMessage: "Cost per message",
                  spent: "Spent so far",
                  estimated: "Estimated total"
                },
                rates: {
                  delivery: "Delivery Rate",
                  read: "Read Rate"
                }
              },
              confirmationModal: {
                deleteTitle: "Delete Campaign",
                deleteMessage: "Are you sure you want to delete \"{{name}}\"? This action cannot be undone.",
                sendTitle: "Send Campaign",
                sendMessage: "Send campaign \"{{name}}\" to {{count}} recipients?",
                stopMessage: "Stop campaign \"{{name}}\"? Unsent messages will not be sent.",
                restartMessage: "Restart campaign \"{{name}}\"? Failed recipients will be reset to pending."
              },
              toasts: {
                success: "Operation completed successfully",
                created: "Campaign created successfully",
                updated: "Campaign updated successfully",
                cancel: "Campaign canceled",
                restart: "Campaign restarted",
                deleted: "Campaign deleted successfully",
                sending: "Campaign sending started!",
                paused: "Campaign paused",
                resumed: "Campaign resumed",
                stopped: "Campaign stopped",
                restarted: "Campaign restarted successfully",
                importSuccess: "Imported {{count}} recipients",
                noRecipients: "Please add recipients before sending",
                fillRequired: "Please fill all required fields",
                selectRecipients: "Please select at least one recipient",
                enterNumbers: "Please enter at least one phone number",
                noData: "No valid data to import",
                filteredNoChatHistory: "filtered - no chat history"
              },
              empty: {
                title: "No campaigns yet",
                description: "Create your first campaign!"
              }
            },
            followUp: {
              tooltip: "Smart Follow-Up",
              dialog: {
                title: "Smart Follow-Up",
                description: "Automatically send a follow-up template if the customer doesn't respond.",
                status: "Follow-Up Active",
                selectTemplate: "Select Template",
                activeTemplate: "Active Template",
                delay: "Send After",
                minutes: "minutes",
                hour: "hour",
                hours: "hours",
                testMode: "Test Mode",
                willSendAfter5min: "Will be sent automatically 5 minutes after your last message (test mode).",
                willSendAfter1h: "Will be sent automatically 1 hour after your last message if customer doesn't reply.",
                willSendAfter24h: "Will be sent automatically 24h after your last message if customer doesn't reply.",
                close: "Close",
                customerName: "Customer Name",
                customerNameHint: "This name will be used in the template ({{1}}). You can edit if needed.",
                fillParameters: "Fill template variables:",
                parameter: "Parameter",
                noParameters: "This template has no dynamic parameters."
              },
              success: {
                enabled: "Follow-up enabled!",
                disabled: "Follow-up disabled."
              },
              errors: {
                selectTemplate: "Please select a template first."
              }
            },
            announcements: {
              title: "Announcements",
              searchPlaceholder: "Search",
              noRecords: "No announcements",
              empty: {
                title: "No active announcements",
                desc: "Internal posts visible to the whole team — perfect for policy updates, org changes, and important notices."
              },
              priority: {
                high: "High",
                medium: "Medium",
                low: "Low"
              },
              status: {
                active: "Active",
                inactive: "Inactive"
              },
              buttons: {
                add: "New Announcement",
                contactLists: "Announcement Lists"
              },
              table: {
                priority: "Priority",
                title: "Title",
                text: "Text",
                mediaName: "File",
                status: "Status",
                actions: "Actions"
              },
              dialog: {
                edit: "Announcement Edit",
                add: "New Announcement",
                update: "Edit Announcement",
                readonly: "Read-only",
                form: {
                  priority: "Priority",
                  title: "Title",
                  text: "Text",
                  mediaPath: "File",
                  status: "Status"
                },
                buttons: {
                  add: "Add",
                  edit: "Update",
                  okadd: "Ok",
                  cancel: "Cancel",
                  close: "Close",
                  attach: "Attach File"
                }
              },
              confirmationModal: {
                deleteTitle: "Delete",
                deleteMessage: "This action cannot be undone."
              },
              toasts: {
                success: "Operation completed successfully",
                deleted: "Record deleted"
              }
            },
            campaignsConfig: {
              title: "Campaign Configurations"
            },
            queues: {
              title: "Queues & Chatbot",
              table: {
                name: "Name",
                color: "Color",
                greeting: "Greeting Message",
                actions: "Actions"
              },
              buttons: {
                add: "Add Queue"
              },
              confirmationModal: {
                deleteTitle: "Delete",
                deleteMessage: "Are you sure? This action cannot be undone! The tickets from this queue will still exist but will no longer be assigned to any queue."
              }
            },
            queueSelect: {
              inputLabel: "Queues"
            },
            queueOptions: {
              forward: "Send to queue"
            },
            users: {
              title: "Users",
              role: {
                admin: "Admin",
                supervisor: "Supervisor",
                user: "User"
              },
              status: {
                online: "Online",
                offline: "Offline"
              },
              table: {
                name: "Name",
                email: "Email",
                profile: "Profile",
                actions: "Actions",
                lastLogin: "Last Login"
              },
              buttons: {
                add: "Add User"
              },
              toasts: {
                deleted: "User deleted successfully."
              },
              confirmationModal: {
                deleteTitle: "Delete",
                deleteMessage: "All user data will be lost. Open tickets from this user will be moved to the queue."
              },
              activity: {
                title: "User Activity",
                filters: {
                  today: "Today",
                  last7: "Last 7 days",
                  last14: "Last 14 days",
                  last21: "Last 21 days",
                  last30: "Last 30 days",
                  month: "Specific month"
                },
                kpis: {
                  lastLogin: "Last Login",
                  totalLogins: "Total Logins",
                  totalConnected: "Total Connected Time",
                  totalActive: "Total Active Time",
                  totalIdle: "Total Idle Time",
                  avgSession: "Avg Session Duration",
                  avgDaily: "Avg Daily Activity"
                },
                sessions: {
                  title: "Session Details",
                  date: "Date",
                  login: "Login",
                  logout: "Logout",
                  duration: "Duration",
                  active: "Active",
                  idle: "Idle",
                  actions: "Actions",
                  noData: "No activity data for the selected period",
                  stillActive: "Active"
                }
              }
            },
            schedules: {
              title: "Schedules",
              confirmationModal: {
                deleteTitle: "Are you sure you want to delete this Schedule?",
                deleteMessage: "This action cannot be undone."
              },
              empty: {
                title: "No schedules yet",
                desc: "Schedule messages ahead of time and send them to customers at exactly the right moment — no need to remember or stay online."
              },
              table: {
                contact: "Contact",
                body: "Message",
                sendAt: "Scheduling Date",
                sentAt: "Sending Date",
                status: "Status",
                actions: "Actions",
                statusMap: {
                  PENDENTE: "Pending",
                  AGENDADA: "Scheduled",
                  ENVIADA: "Sent",
                  ERRO: "Error"
                }
              },
              tabs: {
                all: "All",
                active: "Active",
                done: "Completed",
                noResults: "No tasks in this category"
              },
              buttons: {
                add: "New Schedule"
              },
              toasts: {
                deleted: "Schedule deleted successfully."
              }
            },
            tags: {
              title: "Tags",
              confirmationModal: {
                deleteTitle: "Are you sure you want to delete this Tag?",
                deleteMessage: "This action cannot be undone."
              },
              table: {
                name: "Name",
                color: "Color",
                tickets: "Records",
                actions: "Actions",
                id: "Id",
                kanban: "Kanban"
              },
              buttons: {
                add: "New Tag"
              },
              toasts: {
                deleted: "Tag deleted successfully."
              }
            },
            whatsappBackups: {
              title: "WhatsApp Backups",
              archive: "Archive",
              messages: "Messages",
              contacts: "Contacts",
              media: "Media",
              tabs: {
                all: "All",
                chats: "Chats",
                media: "Media"
              },
              buttons: {
                upload: "Upload Files",
                uploadFolder: "Upload Folder",
                uploading: "Uploading...",
                download: "Download",
                parse: "Parse",
                preview: "Preview Chat",
                restore: "Restore",
                restoring: "Restoring...",
                search: "Search",
                searching: "Searching...",
                validate: "Validate",
                delete: "Delete",
                close: "Close",
                cancel: "Cancel",
                deleteSelected: "Delete Selected",
                deleting: "Deleting...",
                clearSelection: "Clear"
              },
              preview: {
                title: "Chat Preview",
                loading: "Loading preview...",
                noData: "No preview data available",
                dateRange: "Start Date",
                participants: "Participants",
                showingMessages: "Showing {{shown}} of {{total}} messages",
                loadMore: "Load 200 More",
                loadAll: "Load All"
              },
              batchUpload: {
                uploading: "Uploading files...",
                progress: "Progress",
                files: "files",
                batch: "Batch",
                success: "Success",
                failed: "Failed",
                extractedFromZip: "Extracted from ZIP",
                emptyZip: "ZIPs with no chat files"
              },
              toasts: {
                downloadSuccess: "File downloaded successfully",
                parseSuccess: "Backup parsed successfully",
                deleteSuccess: "Backup deleted successfully",
                bulkDeleteSuccess: "Successfully deleted {{count}} backups",
                restoreSuccess: "Backup restored successfully",
                noValidFiles: "No valid backup files found. Supported formats: .txt, .json, .html, .zip",
                noFilesProcessed: "No backup files processed. ZIPs may contain only media files (images, videos, PDFs) - no chat exports found.",
                uploadCancelled: "Upload cancelled",
                uploadSuccess: "Backup uploaded successfully",
                uploadError: "Error uploading backup",
                validateSuccess: "Backup validated successfully",
                restoreError: "Error restoring backup"
              },
              filters: {
                statusLabel: "Status",
                allStatuses: "All statuses",
                phonePlaceholder: "Filter by phone number"
              },
              confirmationModal: {
                deleteTitle: "Delete Backup",
                deleteMessage: "Are you sure you want to delete this backup? This action cannot be undone.",
                bulkDeleteTitle: "Delete Selected Backups",
                bulkDeleteMessage: "Are you sure you want to delete {{count}} selected backups? This action cannot be undone."
              },
              selection: {
                selected: "{{count}} selected"
              },
              table: {
                fileName: "File Name",
                status: "Status",
                size: "Size",
                format: "Format",
                messages: "Messages",
                contacts: "Contacts",
                phone: "Phone Number",
                uploaded: "Uploaded",
                actions: "Actions"
              },
              status: {
                uploaded: "Uploaded",
                processing: "Processing",
                parsed: "Parsed",
                failed: "Failed",
                validated: "Validated"
              },
              dragDrop: {
                title: "Drag & Drop backup file here",
                dropping: "Drop file here",
                subtitle: "or click to browse files",
                formats: "Supported formats: .txt, .json, .html, .zip, .db, .crypt12-15"
              },
              helper: {
                restoreInfo: "Restored chats appear under Tickets → filter \"Closed\". When the same contact sends a new message the latest ticket reopens automatically, keeping history merged in one thread."
              },
              search: {
                title: "Search in Archive",
                byText: "Search by text",
                bySender: "Search by sender",
                byDate: "Search by date",
                placeholder: "Search by name or phone",
                results: "Search Results",
                missingCriteria: "Please enter search text or sender",
                resultsSummary: "Found {{total}} matches (showing first {{limit}})"
              },
              restore: {
                title: "Restore Backup to Live Chats",
                description: "This will import all messages from the backup into live tickets.",
                selectConnection: "WhatsApp Connection",
                customerPhone: "Customer Phone Number",
                customerPhoneHelper: "Enter the phone number of the customer from this chat (with country code, e.g., 380936226260)",
                enterPhone: "Please enter customer phone number",
                foundContact: "Found contact",
                customerInChat: "Customer in chat",
                notFoundInContacts: "not found in contacts, please enter phone manually",
                autoFilled: "Auto-filled from found contact. You can change if needed.",
                file: "File",
                messages: "Messages",
                contacts: "Contacts"
              },
              mainTabs: {
                backups: "Backups",
                history: "Restoration History"
              },
              offlineMode: {
                warning: "You are offline. Showing cached data."
              },
              history: {
                title: "Restoration History",
                empty: "No restoration history yet",
                emptyHint: "Restored conversations will appear here",
                fileName: "Backup File",
                phone: "Phone",
                contact: "Contact",
                messages: "Messages",
                restoredAt: "Restored At",
                result: "Result",
                success: "Success",
                failed: "Failed",
                clearHistory: "Clear History",
                cleared: "History cleared"
              }
            },
            mergeBackupModal: {
              title: "Import Chat History",
              selectBackup: "Please select a backup to import",
              selectBackupHint: "Select a backup file that matches this contact's phone number:",
              noBackups: "No matching backups found",
              noBackupsHint: "Upload backups with phone numbers in the filename to enable import",
              phone: "Phone",
              merge: "Import History",
              merging: "Importing...",
              close: "Close",
              success: "Chat history imported successfully!",
              mergeComplete: "Import Complete",
              messagesCreated: "Messages imported",
              messagesSkipped: "Duplicates skipped"
            },
            settings: {
              customDomain: {
                tab: "Custom Domain",
                title: "Custom domain",
                subtitle: "Serve your CRM on your own address, e.g. crm.yourbrand.com. Add the domain, point the DNS records at us, and we issue the HTTPS certificate automatically.",
                notEntitled: "Custom domains are available on a higher plan. Contact us to enable serving your CRM on your own address.",
                step1: "1. Enter your domain",
                domainLabel: "Domain",
                add: "Add domain",
                step2: "2. Add these DNS records at your provider",
                dnsPropagation: "DNS changes can take up to an hour to propagate. Once the records are live, click Check.",
                dnsNotFound: "Records not detected yet — double-check them and try again.",
                check: "Check DNS",
                remove: "Remove",
                activePrefix: "Your CRM is live at",
                open: "Open",
                statusActive: "Active",
                statusDisabled: "Not configured",
                statusSsl: "Issuing certificate",
                statusDns: "Waiting for DNS",
                copy: "Copy value",
                copied: "Copied",
                reserved: "Domain saved — add the DNS records below.",
                removeConfirm: "Remove this custom domain?",
                removed: "Custom domain removed.",
              },
              group: {
                general: "General",
                generalDesc: "Core bot behaviour",
                timeouts: "Timeouts",
                officeHours: "Office Hours",
                groups: "Groups",
                groupsDesc: "Group chat behaviour and notifications",
                confidenciality: "Confidentiality",
                api: "API",
                apiDesc: "Integration and access",
                serveradmin: "Server administration",
                archive: "Archive"
              },
              success: "Settings saved successfully.",
              title: "Settings",
              updateSuccess: "Updated successfully.",
              pushNotifications: {
                title: "Mobile push notifications",
                subtitle: "Manage push notifications in the mobile app",
                toggle: {
                  title: "Push notifications",
                  helper: "This setting affects the mobile app only."
                },
                scope: {
                  title: "Which messages trigger a notification",
                  all: "All incoming messages",
                  byTag: "Only conversations with selected tags"
                },
                tags: {
                  title: "Selected tags",
                  helper: "A notification is sent only for conversations assigned one of the selected tags.",
                  placeholder: "Select tags",
                  empty: "No tags available — create tags first"
                }
              },
              apiToken: "API Token",
              apiTokenEmpty: "No token generated yet",
              copy: "Copy",
              generateToken: "Generate Token",
              tokenCopied: "Token copied to clipboard",
              settings: {
                userCreation: {
                  name: "User creation",
                  options: {
                    enabled: "Enabled",
                    disabled: "Disabled"
                  }
                }
              },
              validations: {
                title: "validations",
                options: {
                  enabled: "enabled",
                  disabled: "disabled"
                }
              },
              OfficeManagement: {
                title: "Office Management",
                options: {
                  disabled: "disabled",
                  ManagementByDepartment: "Management By Department",
                  ManagementByCompany: "Management By Company"
                }
              },
              outOfHoursAction: {
                title: "Out of Hours Action",
                options: {
                  pending: "Leave as pending",
                  closed: "Close ticket"
                }
              },
              IgnoreGroupMessages: {
                title: "Ignore Group Messages",
                options: {
                  enabled: "enabled",
                  disabled: "disabled"
                }
              },
              soundGroupNotifications: {
                title: "Sound on Group Notifications",
                options: {
                  enabled: "enabled",
                  disabled: "disabled"
                }
              },
              groupsTab: {
                title: "Groups Tab",
                options: {
                  enabled: "enabled",
                  disabled: "disabled"
                }
              },
              VoiceAndVideoCalls: {
                title: "Voice and video calls",
                options: {
                  enabled: "Ignore",
                  disabled: "unavailability report"
                }
              },
              AutomaticChatbotOutput: {
                title: "Automatic Chatbot Output",
                options: {
                  enabled: "enabled",
                  disabled: "disabled"
                }
              },
              chatbotResetDays: {
                title: "Auto Reset Chatbot",
                helper: "Days of inactivity before restarting bot flow",
                options: {
                  never: "Never",
                  day: "day",
                  days: "days"
                }
              },
              systemLanguage: {
                title: "System language",
                helper: "Per-browser. Changing reloads the page.",
                updateSuccess: "Language updated. Reloading..."
              },
              QuickMessages: {
                title: "Quick Messages",
                options: {
                  enabled: "By company",
                  disabled: "By User"
                }
              },
              AllowRegistration: {
                title: "Allow Registration",
                options: {
                  enabled: "enabled",
                  disabled: "disabled"
                }
              },
              FileDownloadLimit: {
                title: "File Download Limit (MB)"
              },
              keepQueueAndUser: {
                title: "Keep queue and user on closed ticket",
                options: {
                  enabled: "Enabled",
                  disabled: "Disabled"
                }
              },
              WelcomeGreeting: {
                greetings: "Hello",
                welcome: "Welcome to",
                expirationTime: "Active until"
              },
              Options: {
                title: "Options"
              },
              GPT: {
                title: "GPT AI"
              },
              Templates: {
                title: "Templates"
              },
              Archive: {
                title: "Archive"
              },
              Companies: {
                title: "Companies"
              },
              schedules: {
                title: "schedules"
              },
              Plans: {
                title: "Plans"
              },
              Help: {
                title: "Help"
              },
              Whitelabel: {
                title: "Whitelabel"
              },
              Subscriptions: {
                title: "Subscriptions"
              },
              Payments: {
                title: "Payments"
              },
              PaymentGateways: {
                title: "Payment gateways"
              },
              sections: {
                general: "General",
                billing: "Billing",
                admin: "Administration"
              },
              companies: {
                subtitle: "{{active}} active · {{expiring}} expiring within 7 days",
                add: "Add Company",
                searchPlaceholder: "Search by name, email or phone...",
                statusLabel: "Status",
                allStatuses: "All statuses",
                activeOnly: "Active only",
                blockedOnly: "Blocked only",
                planLabel: "Plan",
                allPlans: "All plans",
                statusActive: "Active",
                statusBlocked: "Blocked",
                col: {
                  company: "Company",
                  contact: "Contact",
                  plan: "Plan",
                  status: "Status",
                  created: "Created",
                  expiration: "Expiration",
                  actions: "Actions"
                }
              },
              plans: {
                subtitle: "{{publicCount}} public · {{privateCount}} private",
                add: "Add Plan",
                searchPlaceholder: "Search by plan name...",
                visibilityLabel: "Visibility",
                allPlans: "All plans",
                publicOnly: "Public only",
                privateOnly: "Private only",
                public: "Public",
                private: "Private",
                month: "month",
                customPricing: "Custom pricing",
                users: "users",
                connections: "WhatsApp connections",
                queues: "queues",
                editTooltip: "Edit plan",
                deleteTooltip: "Delete plan"
              },
              whitelabel: {
                identity: {
                  title: "Identity",
                  desc: "Your brand name shown across the product"
                },
                colors: {
                  title: "Brand colors",
                  desc: "Primary color used for buttons, tabs and accents"
                },
                assets: {
                  title: "Brand assets",
                  desc: "Logos and favicon for the light/dark themes"
                },
                appName: "System name",
                primaryLight: "Primary — Light mode",
                primaryDark: "Primary — Dark mode",
                logoLight: "Light logo",
                logoDark: "Dark logo",
                favicon: "Favicon",
                upload: "Upload"
              }
            },
            contactWhatsappUsername: {
              label: "WhatsApp Username (@username)",
              placeholder: "john.doe",
              helper: "Optional — unique WhatsApp handle (3-35 chars, lowercase letters / digits / dots / underscores)",
              validation: {
                tooShort: "Username must contain at least 3 characters",
                tooLong: "Username can contain up to 35 characters",
                invalidChars: "Username can only contain lowercase letters, digits, dots, and underscores",
                noWww: "Username cannot start with www.",
                noDomain: "Username cannot end with a domain suffix (.com, .net…)"
              }
            },
            messageInput: {
              chooseEmoji: "Choose emoji",
              noTemplates: "No templates available",
              syncTemplates: "Sync templates from Settings",
              emojiPicker: {
                search: "Search",
                clear: "Clear",
                notfound: "No emojis found",
                categories: {
                  search: "Search results",
                  recent: "Frequently used",
                  smileys: "Smileys",
                  people: "People",
                  nature: "Nature",
                  foods: "Food",
                  activity: "Activities",
                  places: "Places",
                  objects: "Objects",
                  symbols: "Symbols",
                  flags: "Flags"
                }
              }
            },
            time: {
              hourAbbr: "h",
              minuteAbbr: "m",
              dayAbbr: "d"
            },
            messagesList: {
              ack: {
                failed: "Not delivered — Meta may have blocked the message or the phone number is invalid",
                pending: "Pending…",
                sent: "Sent to WhatsApp server",
                delivered: "Delivered to recipient's phone",
                read: "Read by recipient"
              },
              edited: "Edited",
              quotedImage: "Image",
              quotedVideo: "Video",
              quotedAudio: "Voice message",
              quotedDocument: "Document",
              quotedSticker: "Sticker",
              replyToYou: "You",
              header: {
                assignedTo: "Assigned to:",
                today: "Today",
                yesterday: "Yesterday",
                selected: "selected",
                buttons: {
                  return: "Return",
                  resolve: "Resolve",
                  reopen: "Reopen",
                  accept: "Accept",
                  disableAI: "Disable AI",
                  enableAI: "Enable AI",
                  markAsUnread: "Mark as unread"
                }
              },
              invalidVCard: "Invalid contact card data",
              messageContact: "Message",
              addToContacts: "Add to Contacts",
              contactAdded: "Contact added successfully!",
              contactAddError: "Error adding contact",
              contactExists: "This contact already exists in your contacts list.",
              noPhoneNumber: "No phone number available"
            },
            contactDrawerSections: {
              noLinkedChannels: "No linked channels",
              openChat: "Open chat",
              disconnectChannel: "Disconnect channel",
              channelIdPlaceholder: "Channel ID (phone / PSID / email)",
              cancel: "Cancel",
              connect: "Connect",
              connectNewChannel: "Connect new channel",
              statusOpen: "Open",
              statusPending: "Pending",
              statusClosed: "Closed",
              noTicketHistory: "No conversation history",
              totalTickets: "Total chats",
              openTickets: "Open",
              channels: "Channels",
              customerSince: "Customer since",
              communicationChannels: "Communication Channels",
              customerJourney: "Customer Journey"
            },
            voiceTimeline: {
              statusCompleted: "Ended",
              statusNoAnswer: "No answer",
              statusBusy: "Busy",
              statusFailed: "Failed",
              statusActive: "On call",
              statusRinging: "Ringing",
              statusQueued: "Dialing",
              outcomeSale: "Sale",
              outcomeFollowUp: "Follow-up",
              outcomeSupport: "Support",
              outcomePayment: "Payment",
              outcomeComplaint: "Complaint",
              outcomeNoAnswer: "No answer",
              sentimentPositive: "Positive",
              sentimentNeutral: "Neutral",
              sentimentNegative: "Negative",
              sentimentUrgent: "Urgent",
              intentSales: "Sale",
              intentSupport: "Support",
              intentPayment: "Payment",
              intentComplaint: "Complaint",
              intentInformation: "Information",
              minShort: "m",
              secShort: "s",
              seconds: "seconds",
              outgoing: "Outgoing call",
              incoming: "Incoming call",
              recorded: "Recorded",
              recording: "Recording",
              listenRecording: "Listen to recording",
              aiAnalysis: "AI Analysis",
              transcript: "Transcript",
              transcribing: "Transcribing…",
              createTranscript: "Create transcript",
              analyzing: "Analyzing…",
              analyzeCall: "Analyze call",
              noRecording: "No recording for this call.",
              transcriptNotFound: "No transcript found (the call may be too short or silent).",
              quickCharge: "Quick charge",
              followUpAction: "Follow-up & action"
            },
            channelFilter: {
              showAll: "Show all",
              channelLabel: "Channel:",
              label: "Channels",
              all: "Show All",
              whatsapp: "WhatsApp",
              facebook: "Messenger",
              instagram: "Instagram",
              email: "Email",
              telegram: "Telegram",
              businessApi: "WhatsApp Business"
            },
            messagesInput: {
              micRequiresHttps: "Voice recording needs a secure connection (HTTPS) and microphone access",
              placeholderOpen: "Type a message",
              placeholderClosed: "Reopen or accept this ticket to send a message.",
              signMessage: "Sign",
              replying: "Replying",
              editing: "Editing"
            },
            message: {
              edited: "Edited",
              forwarded: "Forwarded",
              from: "from"
            },
            quickCharge: {
              button: "Quick Charge",
              title: "Quick Charge",
              customer: "Customer",
              amount: "Amount",
              reason: "Reason",
              defaultReason: "Payment for service",
              create: "Create payment",
              cancel: "Cancel",
              created: "Payment request created",
              linkHint: "Send the link to the customer in chat, or copy it",
              noLink: "Payment request created, but no Tranzila account is configured for a link.",
              noLinkButCreated: "Created — configure Tranzila to get a link",
              done: "Close",
              copy: "Copy link",
              copied: "Link copied",
              sendToChat: "Send in chat",
              sent: "Link sent to customer",
              chatPrefix: "Secure payment for",
              invalidAmount: "Enter a valid amount"
            },
            errorBoundary: {
              pageTitle: "Something went wrong loading this screen",
              pageBody: "Try reloading. The rest of the system keeps working.",
              reload: "Reload",
              sectionFailed: "This section couldn't load right now."
            },
            voiceIntelligence: {
              title: "Voice Intelligence — Control Center",
              calls: {
                filters: {
                  search: "Search",
                  agent: "Agent",
                  outcome: "Outcome",
                  has: "Has",
                  all: "All",
                  hasRecording: "With recording",
                  hasTranscript: "With transcript",
                  hasAnalysis: "With AI analysis",
                  qa: "QA",
                  noOutcome: "Without outcome",
                  noTranscript: "Without transcript",
                  noAnalysis: "Without AI analysis",
                  minMinutes: "Min minutes",
                  maxMinutes: "Max minutes"
                },
                columns: {
                  date: "Date",
                  customer: "Customer",
                  agent: "Agent",
                  outcome: "Outcome",
                  duration: "Duration",
                  tags: "Tags",
                  actions: "Actions"
                },
                actions: {
                  listen: "Listen",
                  download: "Download recording",
                  transcript: "Transcript",
                  openTicket: "Open conversation (customer)"
                },
                exportCsv: "Export CSV",
                exportXlsx: "Export Excel",
                exportSelectedCsv: "Export selected CSV",
                exportSelectedXlsx: "Export selected Excel",
                selected: "{{count}} selected",
                empty: "No calls for the selected range/filters",
                transcriptTitle: "Call transcript",
                noTranscript: "No transcript available"
              },
              agentsPerf: {
                topSales: "Top Sales Agent",
                topSupport: "Top Support Agent",
                topCollection: "Top Collection Agent",
                mostActive: "Most Active",
                highestConversion: "Highest Conversion",
                tableTitle: "Agent Performance",
                agent: "Agent",
                calls: "Calls",
                answered: "Answered",
                avgDuration: "Avg Duration",
                conversion: "Conversion",
                unassigned: "Unassigned",
                empty: "No data for the range"
              },
              insights: {
                kpis: {
                  conversionRate: "Conversion Rate",
                  followUpRate: "Follow-Up Rate",
                  noAnswerRate: "No-Answer Rate",
                  complaintRate: "Complaint Rate",
                  collectionSuccessRate: "Collection Success",
                  collectionPromiseRate: "Payment Promises"
                },
                heatmapTitle: "Heatmap — calls by hour and day",
                noData: "No data yet",
                topObjections: "Top Objections",
                topActionItems: "Top Action Items",
                topIntents: "Top Topics",
                sentiment: "Sentiment",
                days: {
                  sun: "Sun",
                  mon: "Mon",
                  tue: "Tue",
                  wed: "Wed",
                  thu: "Thu",
                  fri: "Fri",
                  sat: "Sat"
                },
                ask: {
                  title: "Ask AI about your calls",
                  placeholder: "e.g. What are customers complaining about this month? What destinations are trending?",
                  button: "Ask",
                  noData: "Not enough call data to answer"
                }
              },
              collectionTab: {
                filters: {
                  all: "All",
                  pending: "Pending",
                  promised: "Promise to Pay",
                  paid: "Paid",
                  overdue: "Overdue"
                },
                columns: {
                  date: "Date",
                  customer: "Customer",
                  agent: "Agent",
                  amountDue: "Due",
                  amountPromised: "Promised",
                  dueDate: "Due Date",
                  status: "Status",
                  actions: "Actions"
                },
                status: {
                  pending: "Pending",
                  promised: "Promised",
                  paid: "Paid",
                  failed: "Failed"
                },
                openTicket: "Open conversation",
                empty: "No collection calls for this filter"
              },
              branding: {
                title: "Voice Branding",
                note: "Branded welcome message and waiting music for calls. Settings are saved now; in-call playback activates only after Phase 1 live validation.",
                enable: "Enable voice branding",
                welcomeTitle: "Welcome message",
                welcomeText: "Welcome text (spoken via TTS)",
                welcomeTextHint: "If a file is also selected, the file wins",
                welcomeAsset: "Welcome file (MP3)",
                waitingAsset: "Waiting music (MP3)",
                language: "Language",
                none: "None",
                assetsTitle: "Audio assets",
                uploadKind: "Kind",
                upload: "Upload file",
                noAssets: "No assets yet — upload your first MP3",
                preview: "Preview",
                delete: "Delete",
                saved: "Saved",
                uploaded: "File uploaded",
                previewFailed: "Preview failed",
                kinds: {
                  welcome: "Welcome",
                  waiting: "Waiting",
                  announcement: "Announcement"
                }
              },
              search: {
                placeholder: "Search transcripts, AI summaries, customer memory and notes…",
                button: "Search",
                results: "{{count}} results",
                empty: "No results — try different wording",
                loadMore: "Load more",
                openTicket: "Open conversation",
                scopes: {
                  all: "All",
                  transcripts: "Transcripts",
                  analyses: "AI Summaries",
                  memory: "Customer Memory",
                  notes: "Call Notes"
                },
                sources: {
                  transcript: "Transcript",
                  analysis: "AI Analysis",
                  memory: "Memory",
                  notes: "Notes"
                }
              },
              outcomes: {
                sale: "Sale",
                follow_up: "Follow Up",
                support: "Support",
                collection: "Collection",
                complaint: "Complaint",
                no_answer: "No Answer",
                wrong_number: "Wrong Number"
              },
              tabs: {
                overview: "Overview",
                calls: "Calls",
                search: "Search",
                agents: "Agents",
                collection: "Collection",
                insights: "Insights"
              },
              range: {
                label: "Range",
                days7: "7 days",
                days30: "30 days",
                days90: "90 days"
              },
              widgets: {
                totalCalls: "Total Calls",
                totalDuration: "Total Duration",
                avgDuration: "Avg Duration",
                callsToday: "Calls Today",
                callsThisWeek: "Calls This Week",
                callsThisMonth: "Calls This Month",
                callsAnalyzed: "Calls Analyzed",
                callsPendingAnalysis: "Pending Analysis",
                collectionCalls: "Collection Calls",
                vipCalls: "VIP Calls",
                followUpRequired: "Follow-Up Required"
              },
              agents: {
                title: "Calls by Agent",
                agent: "Agent",
                calls: "Calls",
                duration: "Total Duration",
                avgDuration: "Average",
                unassigned: "Unassigned",
                empty: "No calls in the selected range"
              },
              notEnabled: {
                title: "Voice module is not enabled",
                body: "Enable Voice in settings to see call data, or contact your administrator."
              }
            },
            voice: {
              callButton: "Call customer",
              section: {
                memory: "Customer Memory",
                calls: "Calls",
                collection: "Collection",
                timeline: "Communication Timeline"
              },
              timeline: {
                search: "Search communication…"
              },
              wizard: {
                step1: "Intro",
                step2: "Connect",
                step3: "Done",
                introTitle: "What you get with Voice:",
                credsHint: "Enter the API key from your Telnyx account and your number. Whapiz sets up all the technical config (webhook, application) automatically — you never touch a Telnyx screen.",
                connect: "Connect automatically",
                done: "Voice is connected and ready!",
                back: "Back",
                next: "Next",
                finish: "Finish"
              },
              verify: {
                button: "Verify number",
                code: "Verification code",
                confirm: "Confirm",
                resend: "Resend",
                sent: "Code sent by SMS",
                devCode: "Code (test)",
                verified: "Verified ✓"
              },
              bar: {
                ringing: "Ringing",
                inCall: "In call",
                ended: "Call ended",
                recording: "Recording",
                mute: "Mute",
                hangup: "Hang up",
                dismiss: "Close",
                outcomePrompt: "Call outcome:"
              },
              outcome: {
                sale: "Sale",
                followUp: "Follow-up",
                support: "Support",
                payment: "Payment",
                complaint: "Complaint",
                noAnswer: "No answer"
              },
              memory: {
                title: "Customer Memory",
                confirmed: "Confirmed",
                suggested: "AI suggestions — pending review",
                empty: "No memory yet for this customer",
                confirm: "Confirm",
                dismiss: "Dismiss",
                edit: "Edit",
                delete: "Delete",
                add: "Add memory",
                source: "Source",
                fromCall: "From call",
                types: {
                  fact: "Fact",
                  preference: "Preference",
                  risk: "Risk",
                  commitment: "Commitment"
                }
              },
              calls: {
                title: "Calls",
                empty: "No calls yet",
                listen: "Listen",
                transcript: "Transcript",
                analyze: "Analyze call",
                duration: "Duration",
                outcome: "Outcome",
                agent: "Agent",
                analyzing: "Analyzing…",
                transcribing: "Transcribing… try again shortly",
                noTranscript: "No transcript available"
              },
              analysis: {
                title: "Call analysis",
                summary: "Summary",
                intent: "Intent",
                sentiment: "Sentiment",
                objections: "Objections",
                actionItems: "Action items",
                suggestedReply: "Suggested follow-up"
              },
              collection: {
                title: "Collection",
                empty: "No collection records",
                amountDue: "Amount",
                reason: "Reason",
                script: "Call script",
                generateScript: "Generate script",
                paymentLink: "Send payment link",
                create: "Open collection",
                status: "Status"
              },
              settings: {
                title: "Voice settings",
                outgoing: "Enable outgoing calls",
                recording: "Enable recording",
                transcription: "Enable transcription",
                aiAnalysis: "Enable AI analysis",
                paymentAssist: "Enable collection assistant",
                consent: "Recording announcement",
                save: "Save",
                myPhone: "My phone for calls",
                myPhoneHint: "When you click Call, the system rings this number first — answer it and you're bridged to the customer. A real call, no browser/headset needed."
              },
              connections: {
                title: "Voice connections",
                add: "Connect provider",
                test: "Test connection",
                testCall: "Test call",
                delete: "Delete",
                provider: "Provider",
                phoneNumber: "Phone number",
                status: "Status",
                note: "Whapiz does not provide phone numbers or telecom services. You connect your own provider account and all call costs are billed directly by your provider."
              }
            },
            contactDrawer: {
              header: "Contact Information",
              buttons: {
                edit: "Edit Contact"
              },
              extraInfo: "Other Information",
              chatbotNotes: {
                title: "Chatbot Notes"
              },
              travelRequest: {
                title: "Travel Request",
                score: "score",
                matchedOffers: "Matched Offers ({{count}})",
                fields: {
                  destination: "🌍 Destination",
                  country: "🗺️ Country",
                  productType: "✈️ Type",
                  familyComposition: "👨‍👩‍👧 Composition",
                  adults: "🧑 Adults",
                  children: "👶 Children",
                  childrenAges: "🎂 Ages",
                  checkInDate: "📅 Check-in",
                  checkOutDate: "📅 Check-out",
                  nights: "🌙 Nights",
                  boardBasis: "🍽️ Board",
                  budget: "💰 Budget",
                  currency: "💱 Currency",
                  preferences: "⭐ Preferences"
                },
                board: {
                  all_inclusive: "All inclusive",
                  full_board: "Full board",
                  half_board: "Half board",
                  bed_breakfast: "Bed & breakfast",
                  room_only: "Room only"
                },
                product: {
                  flight_hotel: "Flight + Hotel",
                  flight_only: "Flight only",
                  hotel_only: "Hotel only"
                }
              }
            },
            contactNotes: {
              toasts: {
                added: "Note added",
                deleted: "Note deleted"
              },
              confirm: {
                title: "Delete note",
                message: "Are you sure you want to delete this note?"
              }
            },
            ticketOptionsMenu: {
              schedule: "Schedule",
              scheduleAppointment: "📅 Schedule appointment",
              appointmentTriggering: "Starting appointment bot…",
              appointmentTriggered: "Appointment bot started — greeting sent.",
              delete: "Delete",
              transfer: "Transfer",
              resetChatbot: "🔄 Reset Chatbot",
              requestPayment: "💳 Request payment",
              mergeBackup: "Import History",
              downloadConversation: "📥 Download Conversation",
              downloading: "Downloading...",
              registerAppointment: "Contact Notes",
              appointmentsModal: {
                title: "Contact Notes",
                textarea: "Note",
                placeholder: "Insert the information you want to record here"
              },
              confirmationModal: {
                title: "Delete contact ticket",
                message: "Attention! All messages related to the ticket will be lost."
              },
              buttons: {
                delete: "Delete",
                cancel: "Cancel"
              }
            },
            confirmationModal: {
              buttons: {
                confirm: "Ok",
                cancel: "Cancel"
              }
            },
            messageOptionsMenu: {
              delete: "Delete",
              edit: "Edit",
              history: "History",
              reply: "Reply",
              copy: "Copy",
              copied: "Text copied",
              forward: "Forward",
              forwardbutton: "Select user to forward message",
              reactions: "Reactions",
              removeReactions: "Remove reaction",
              confirmationModal: {
                title: "Delete message?",
                message: "This action cannot be undone."
              }
            },
            messageHistoryModal: {
              close: "Close",
              title: "Message edit history"
            },
            presence: {
              unavailable: "Unavailable",
              available: "Available",
              composing: "Composing...",
              recording: "Recording...",
              paused: "Paused"
            },
            privacyModal: {
              title: "Edit Whatsapp Privacy",
              buttons: {
                cancel: "Cancel",
                okEdit: "Save"
              },
              form: {
                menu: {
                  all: "All",
                  none: "Nobody",
                  contacts: "My contacts",
                  contact_blacklist: "Selected contacts",
                  match_last_seen: "Match Last Seen",
                  known: "Known",
                  disable: "Disabled",
                  hrs24: "24 Hours",
                  dias7: "7 Days",
                  dias90: "90 Days"
                },
                readreceipts: "To update the Read Receipts privacy",
                profile: "To update the Profile Picture privacy",
                status: "To update the Messages privacy",
                online: "To update the Online privacy",
                last: "To update the LastSeen privacy",
                groupadd: "To update the Groups Add privacy",
                calladd: "To update the Call Add privacy",
                disappearing: "To update the Default Disappearing Mode"
              }
            },
            contactProfile: {
              title: "Customer Intelligence",
              emptyState: "Profile will be built automatically from conversation",
              confidence: "Confidence",
              updated: "Updated",
              profileNotBuilt: "Profile not built yet",
              sections: {
                personal: "Personal",
                travel: "Travel Interests",
                family: "Family",
                preferences: "Preferences"
              },
              labels: {
                name: "Name",
                language: "Language",
                country: "Country",
                destinations: "Destinations",
                months: "Months",
                duration: "Duration",
                budget: "Budget",
                accommodation: "Accommodation",
                adults: "Adults",
                children: "Children",
                ages: "Ages",
                requirements: "Requirements",
                interest: "Interest",
                style: "Style",
                activities: "Activities"
              },
              fields: {
                customerName: "Customer name",
                destination: "Destination",
                travelDates: "Travel dates/months",
                adultsCount: "Number of adults",
                childrenAges: "Children ages"
              },
              readyToBook: {
                title: "Ready-to-Book",
                statusReady: "Ready",
                statusAlmost: "Almost",
                statusMissing: "Missing Info",
                noProfile: "No Profile",
                noProfileDesc: "Customer profile needed before generating booking summary. Profile is built automatically as AI extracts info from conversation.",
                missingInfo: "Missing information",
                generating: "Generating...",
                generateSummary: "Generate Booking Summary",
                tryGenerate: "Try Generate Anyway",
                copyToClipboard: "Copy to clipboard",
                statusReadyFull: "Ready to Book",
                statusAlmostFull: "Almost Ready",
                statusMoreInfo: "More Info Needed"
              },
              toasts: {
                ticketRequired: "Ticket ID required to generate summary",
                generateFailed: "Failed to generate booking summary",
                copied: "Summary copied to clipboard"
              }
            },
            backendErrors: {
              ERR_VOICE_DIAL_FAILED: "The call could not be placed. Check that calls to this destination country are enabled for the account.",
              ERR_META_MEDIA_UNSUPPORTED: "Sending files isn't supported on this channel yet.",
              ERR_MEDIA_TOO_LARGE: "This file is too large to send on this channel (max 20 MB).",
              ERR_META_SEND_FAILED: "Message could not be sent on this channel — try again.",
              ERR_META_TOKEN_INVALID: "Channel connection expired — reconnect it in settings.",
              ERR_FACEBOOK_WINDOW_EXPIRED: "The 24-hour reply window has closed; the customer must message first.",
              ERR_META_COMMENT_REPLY_NOT_PERMITTED: "Facebook does not permit a private reply to a post comment (App Review required). To reply, the customer must message you on Messenger.",
              ERR_EDIT_NOT_SUPPORTED_FOR_CHANNEL: "Editing messages isn't supported on this channel.",
              ERR_DELETE_NOT_SUPPORTED_FOR_CHANNEL: "Deleting messages isn't supported on this channel.",
              ERR_CANNOT_FORWARD_TO_OMNICHANNEL: "Forwarding to this channel isn't supported.",
              ERR_CANNOT_FORWARD_FROM_OMNICHANNEL: "Forwarding from this channel isn't supported.",
              ERR_MESSAGE_BODY_REQUIRED: "Message text is required.",
              ERR_NO_OTHER_WHATSAPP: "There must be at least one default WhatsApp.",
              ERR_NO_DEF_WAPP_FOUND: "No default WhatsApp found. Check the connections page.",
              ERR_WAPP_NOT_INITIALIZED: "This WhatsApp session has not been initialized. Check the connections page.",
              ERR_WAPP_CHECK_CONTACT: "Could not check WhatsApp contact. Check the connections page.",
              ERR_WAPP_INVALID_CONTACT: "This is not a valid WhatsApp number.",
              ERR_WAPP_DOWNLOAD_MEDIA: "Could not download media from WhatsApp. Check the connections page.",
              ERR_INVALID_CREDENTIALS: "Authentication error. Please try again.",
              ERR_SENDING_WAPP_MSG: "Error sending WhatsApp message. Check the connections page.",
              ERR_DELETE_WAPP_MSG: "Could not delete WhatsApp message.",
              ERR_EDITING_WAPP_MSG: "Could not edit WhatsApp message.",
              ERR_OTHER_OPEN_TICKET: "There is already an open ticket for this contact.",
              ERR_SESSION_EXPIRED: "Session expired. Please log in.",
              ERR_USER_CREATION_DISABLED: "User creation has been disabled by the administrator.",
              ERR_NO_PERMISSION: "You do not have permission to access this resource.",
              ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
              ERR_NO_SETTING_FOUND: "No setting found with this ID.",
              ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
              ERR_NO_TICKET_FOUND: "No ticket found with this ID.",
              ERR_NO_USER_FOUND: "No user found with this ID.",
              ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
              ERR_CREATING_MESSAGE: "Error creating message in the database.",
              ERR_CREATING_TICKET: "Error creating ticket in the database.",
              ERR_FETCH_WAPP_MSG: "Error fetching message from WhatsApp, perhaps it is too old.",
              ERR_QUEUE_COLOR_ALREADY_EXISTS: "This color is already in use, choose another.",
              ERR_WAPP_GREETING_REQUIRED: "Greeting message is mandatory when there is more than one queue."
            },
            godeal: {
              support: {
                title: "Support godeal project",
                mercadopagotitle: "Credit Card",
                recurringbrl: "Recurring donations in BRL",
                paypaltitle: "Credit Card",
                international: "Donations in USD"
              }
            },
            scheduleMessageModal: {
              title: "Schedule Message",
              messagePreview: "Message to send:",
              noMessage: "No message entered",
              quickSelect: "Quick select:",
              minutes: "min",
              hour: "hour",
              hours: "hours",
              tomorrow: "Tomorrow",
              dateTime: "Date & Time",
              sendTo: "Will be sent to:",
              cancel: "Cancel",
              schedule: "Schedule",
              scheduling: "Scheduling...",
              success: "Message scheduled successfully!",
              errors: {
                noMessage: "Please enter a message first",
                noDate: "Please select date and time",
                pastDate: "Please select a future date"
              }
            },
            teams: {
              title: "Teams Management",
              stats: {
                totalTeams: "Total Teams",
                totalMembers: "Total Members"
              },
              empty: {
                title: "No teams yet",
                description: "Create your first team to organize your agents"
              },
              table: {
                name: "Team Name",
                description: "Description",
                members: "Members",
                actions: "Actions"
              },
              buttons: {
                new: "New Team",
                createFirst: "Create First Team",
                cancel: "Cancel",
                create: "Create",
                save: "Save"
              },
              membersCount: "members",
              noMembers: "No members",
              dialog: {
                newTitle: "New Team",
                editTitle: "Edit Team"
              },
              form: {
                name: "Team Name",
                description: "Description",
                members: "Team Members",
                searchUsers: "Search users...",
                noUsersFound: "No users found",
                tryDifferentSearch: "Try a different search term"
              },
              actions: {
                edit: "Edit",
                delete: "Delete"
              },
              deleteConfirm: {
                title: "Delete Team",
                message: "Are you sure you want to delete this team?"
              },
              messages: {
                created: "Team created successfully",
                updated: "Team updated successfully",
                deleted: "Team deleted successfully"
              },
              errors: {
                loadFailed: "Failed to load teams",
                saveFailed: "Failed to save team",
                deleteFailed: "Failed to delete team",
                nameRequired: "Team name is required"
              }
            },
            aiWizard: {
              title: "AI Configuration",
              subtitle: "Set up your AI assistant in a few simple steps",
              steps: {
                companyInfo: "Company Info",
                aiAgent: "AI Agent",
                dataSources: "Data Sources",
                externalCrm: "External CRM",
                handoffRules: "Handoff Rules",
                greeting: "Greeting"
              },
              next: "Next",
              back: "Back",
              finishSave: "Finish & Save",
              savedSuccess: "AI configuration saved successfully!",
              saveFailed: "Failed to save configuration",
              companyStep: {
                companyName: "Company Name",
                companyNamePlaceholder: "e.g. My Travel Agency",
                timezone: "Timezone",
                responseLanguage: "Response Language",
                timezones: {
                  israel: "Israel (Asia/Jerusalem)",
                  uk: "UK (Europe/London)",
                  usEast: "US East (America/New_York)",
                  ukraine: "Ukraine (Europe/Kiev)"
                },
                languages: {
                  hebrew: "Hebrew (עברית)",
                  english: "English",
                  russian: "Russian (Русский)",
                  arabic: "Arabic (العربية)"
                }
              },
              aiStep: {
                describeCompany: "Describe your company and AI behavior",
                describePlaceholder: "e.g. We are a travel agency specializing in family vacations. The AI should be helpful, suggest destinations, and collect customer preferences...",
                tone: "Communication Tone",
                model: "AI Model",
                tones: {
                  professional: "Professional",
                  friendly: "Friendly",
                  formal: "Formal"
                },
                models: {
                  gpt4o: "GPT-4o (Best quality)",
                  gpt4oMini: "GPT-4o Mini (Faster, cheaper)"
                }
              },
              dataStep: {
                description: "Connect external APIs so the AI can fetch real data (products, inventory, prices) during conversations. This is optional.",
                summaryTemplate: "Summary display template",
                summaryPlaceholder: "How to show collected data before results. Use {{fields}} as placeholder.",
                dataSourceNum: "Data Source #{{num}}",
                name: "Name",
                namePlaceholder: "e.g. Product Catalog",
                apiUrl: "API URL",
                apiUrlPlaceholder: "https://api.mycompany.com/products",
                description2: "Description (for AI)",
                descriptionPlaceholder: "Search products by customer criteria",
                requiredFields: "Required Fields (comma-separated)",
                requiredFieldsPlaceholder: "e.g. category, budget, size, preferred style",
                requiredFieldsHelper: "AI will collect these fields one by one before searching",
                addDataSource: "Add Data Source"
              },
              crmStep: {
                description: "Optionally connect an external CRM (Supabase) to auto-fill customer details from your database. You can skip this step.",
                enable: "Enable External CRM",
                supabaseUrl: "Supabase URL",
                supabaseKey: "Supabase API Key",
                testConnection: "Test Connection",
                tableName: "Lookup Table",
                phoneField: "Phone Column",
                nameFields: "Name Columns",
                nameFieldsHelp: "Comma-separated, e.g. first_name, last_name",
                detectedFields: "Detected columns",
                skipNote: "This step is optional. If you don't have an external CRM, just click Next."
              },
              handoffStep: {
                description: "Define when the AI should transfer the conversation to a human agent.",
                customPlaceholder: "Describe custom handoff condition...",
                addCustomRule: "Add Custom Rule",
                triggers: {
                  pricing: "Customer asks about pricing",
                  complaint: "Customer complaint",
                  humanRequest: "Customer asks for human agent",
                  aiFailure: "AI cannot answer"
                }
              },
              greetingStep: {
                enableGreeting: "Enable automatic greeting",
                greetingMessage: "Greeting Message",
                greetingPlaceholder: "e.g. Hi! Welcome to our store. How can I help you today?"
              }
            },
            tour: {
              buttons: {
                back: "Back",
                close: "Close",
                last: "Finish",
                next: "Next",
                skip: "Skip tour"
              },
              welcome: {
                title: "Welcome to Whapiz! 👋",
                content: "Let's set up your business in 4 simple steps. It takes about 5 minutes."
              },
              connections: {
                title: "Step 1 — Connect your WhatsApp number",
                content: "Click here to open the Connections page where you'll add your WhatsApp Business API number.",
                contentMobile: "Tap the ☰ menu in the top-left, then choose 'Connections'. That's where you connect your WhatsApp Business API number."
              },
              metaButton: {
                title: "Click 'Connect WhatsApp Business API'",
                content: "Your team will provide you with 3 values from Meta Business Manager: Phone Number ID, WABA ID, and an API Token. Paste them in the wizard's step 2 and you're done."
              },
              queues: {
                title: "Step 2 — Create your first queue",
                content: "Queues organize incoming chats by department or topic (Sales, Support, Billing…). Click here, then '+Add' to create your first one.",
                contentMobile: "Tap the ☰ menu, then 'Queues'. Queues organize incoming chats by department (Sales, Support, Billing…). Tap '+Add' to create your first one."
              },
              botChoice: {
                title: "Step 3 — Choose how your bot replies",
                content: "You have two options:\n\n📋 SIMPLE MENU BOT — Customers see a numbered menu (1 - Sales, 2 - Support…). Easy to set up inside each Queue → Options tab.\n\n🤖 AI ASSISTANT — GPT-4 answers in natural language. Best for sales and complex questions. The next step opens the AI setup wizard for you.\n\nYou can skip this for now and decide later."
              },
              aiSettings: {
                title: "AI Assistant (optional)",
                content: "Fill in the 6 short steps to teach the AI about your business: company info, tone of voice, knowledge sources, CRM integration, when to hand off to a human, and the greeting. The AI uses GPT-4 and answers in your customer's language. Skip this step if you'd rather use a simple menu bot."
              },
              users: {
                title: "Step 4 — Invite your team",
                content: "Add the agents who will handle customer chats. Each agent gets their own login and inbox.",
                contentMobile: "Tap the ☰ menu, then 'Users'. Add the agents who'll handle customer chats — each agent gets their own login and inbox."
              },
              done: {
                title: "🎉 You're all set!",
                content: "Your customers can now message you and your team can reply from here. You can restart this tour anytime from your profile menu."
              }
            },
            setupAssistant: {
              title: "AI Setup Assistant",
              subtitle: "Describe your business — I'll configure the bot",
              welcomeTitle: "How can I help you set up?",
              welcomeText: "Describe your business or pick a quick start below:",
              welcomeQuestions: "Hi! I'll help you set up your WhatsApp bot. Let's start with a few questions:\n\n1. **Bot mode** — which do you prefer?\n• **Chatbot** — menu with categories, structured questions\n• **Direct AI** — free conversation, no menus\n\n2. **Categories** — what topics do your customers contact you about? (e.g., repairs, billing, appointments...)\n\n3. **CRM** — do you have a customer database you want to connect?\n\nPlease answer and we'll build your bot step by step!",
              inputPlaceholder: "Describe your business...",
              error: "Sorry, something went wrong. Please try again.",
              applied: "Configuration applied! Review the fields and click Save.",
              configReady: "Configuration Ready",
              applyConfig: "Apply Configuration",
              restart: "Start over",
              suggestions: {
                building: "Building management company",
                clinic: "Medical clinic",
                restaurant: "Restaurant / food delivery",
                cleaning: "Cleaning services",
                law: "Law firm"
              },
              config: {
                company: "Company",
                mode: "Bot Mode",
                language: "Language",
                tone: "Tone",
                queues: "Queues",
                greeting: "Greeting",
                tasks: "Auto Tasks",
                crm: "CRM Integration"
              }
            },
            subscriptionsManager: {
              title: "Company Subscriptions",
              subtitle: "Plan assignments and billing across all tenants",
              loadFailed: "Failed to load subscriptions",
              assignPlan: "Assign Plan",
              assignSuccess: "Plan assigned successfully",
              assignFailed: "Failed to assign plan",
              cancelConfirm: "Are you sure you want to cancel this subscription?",
              cancelSuccess: "Subscription cancelled",
              cancelFailed: "Failed to cancel subscription",
              recordPayment: "Record Payment",
              paymentSuccess: "Payment recorded successfully",
              paymentFailed: "Failed to record payment",
              refresh: "Refresh",
              autoRenew: "Auto-renew",
              autoRenewOn: "Auto-renew on",
              autoRenewOff: "Auto-renew off",
              autoRenewSaved: "Auto-renew updated",
              autoRenewError: "Couldn't update auto-renew",
              autoRenewSaving: "Saving…",
              cancel: "Cancel",
              noSubscriptions: "No subscriptions yet. Assign plans to companies to get started.",
              emptyDescription: "No subscriptions yet. Tenants will appear here once they activate a plan.",
              table: {
                company: "Company",
                plan: "Plan",
                status: "Status",
                period: "Billing Period",
                 autoRenew: "Auto-renew",
                actions: "Actions"
              },
              form: {
                companyId: "Company ID",
                plan: "Plan",
                status: "Status",
                periodMonths: "Period (months)",
                amount: "Amount",
                currency: "Currency",
                description: "Description",
                type: "Payment Type",
                cancel: "Cancel",
                assign: "Assign",
                record: "Record Payment"
              }
            },
            billingPage: {
    paymentVerifying: "Verifying your payment…",
    paymentVerifyingDesc: "Please wait while we confirm the transaction with the payment provider.",
    paymentSuccessNoRef: "Payment reference missing",
    paymentSuccessNoRefDesc: "We couldn’t find a transaction reference to verify. Please check your billing page.",
    paymentPendingTitle: "Payment is still processing",
    paymentPendingSubtitle: "We haven’t received a final confirmation yet. This can take a moment.",
    paymentCheckAgain: "Check again",
    paymentNotFoundTitle: "Transaction not found",
    paymentNotFoundSubtitle: "We couldn’t find this transaction. If you were charged, contact support.",
    paymentFailedTitle: "Payment did not go through",
    paymentFailedSubtitle: "The transaction was not completed. You have not been charged.",
    paymentSupportLine: "Need help? Contact us at {{email}}.",
    backToBilling: "Back to billing",
    backToDashboard: "Back to dashboard",
    viewInvoices: "View invoices",
    psPlan: "Plan",
    psBillingPeriod: "Billing period",
    psReference: "Reference",
    psDate: "Date",
    psCard: "Card",
    psStarts: "Subscription starts",
    psNextCharge: "Next charge",
    psAutoRenew: "Auto-renew",
    psAutoRenewOff: "Auto-renew off",
    psAmount: "Amount charged",
    psInvoiceSent: "An invoice was sent to {{email}}.",
    psInvoiceNote: "Your invoice is available on the billing page.",
    interval_monthly: "Monthly",
    interval_yearly: "Yearly",
    on: "On",
    off: "Off",

              paymentSuccessTitle: "Payment successful",
              paymentSuccessSubtitle: "Your subscription is now active",
              paymentSuccessPlanLabel: "Plan",
              paymentSuccessNext: "An invoice has been sent to your email. You can manage your subscription anytime below.",
              paymentSuccessCta: "Done",
              cancelSubscription: "Cancel subscription",
              resumeAutoRenew: "Resume auto-renew",
              cancelConfirmTitle: "Turn off auto-renew?",
              cancelConfirmBody: "Your subscription stays active until {{date}}, then it won't renew. You can turn it back on anytime.",
              cancelConfirmKeep: "Keep subscription",
              cancelConfirmYes: "Cancel subscription",
              title: "Billing & Subscription",
              subtitle: "Manage your subscription plan, payment history, and invoices",
              loadFailed: "Failed to load billing data",
              tabs: {
                overview: "Plan Overview",
                payments: "Payment History",
                invoices: "Invoices & Receipts"
              },
              currentPlan: "Current Plan",
              noPlan: "No Plan Assigned",
              noPlanDesc: "Contact your administrator to assign a subscription plan.",
              noSubscription: "No active subscription. Your plan is assigned but billing hasn't started yet.",
              perMonth: "month",
              perYear: "year",
              trialBilling: "Trial period",
              periodStart: "Period Start",
              periodEnd: "Period End",
              trialEnds: "Trial Ends",
              features: {
                users: "Users",
                connections: "WhatsApp Connections",
                queues: "Queues",
                ai: "AI Agent Included",
                crm: "CRM Integration"
              },
              paymentHistory: "Payment History",
              noPayments: "No payments yet. Your payment history will appear here.",
              invoiceHistory: "Invoices & Receipts",
              noInvoices: "No invoices yet. Your invoices will appear here after payments.",
              downloadInvoice: "Download Invoice",
              payNow: "Pay now",
              renewSubscription: "Renew subscription",
              renewDesc: "Continue your plan and keep access uninterrupted.",
              renewLoading: "Processing…",
              renewFailed: "Renewal failed. Please try again.",
              paymentSuccess: "Payment successful",
              paymentFailed: "Payment failed",
              pastDueBanner: "Your subscription is past due. Pay to restore access.",
              trialBanner: "Your trial is active. Upgrade anytime to keep access after it ends.",
              noTerminal: "No payment terminal configured. Contact support.",
              table: {
                date: "Date",
                description: "Description",
                amount: "Amount",
                status: "Status",
                method: "Method",
                invoice: "Invoice #",
                actions: "Actions"
              }
            },
            requestPaymentDialog: {
              title: "Request payment",
              confirmTitle: "Confirm payment request",
              recipient: "Recipient",
              unnamedContact: "this contact",
              amountLabel: "Amount",
              currencyLabel: "Currency",
              descriptionLabel: "Description",
              descriptionHelp: "Shown to the customer on the Tranzila page. Max 80 chars.",
              confirmBody: "Send a payment link for",
              confirmTo: "to",
              confirmHelp: "The link will be delivered as a WhatsApp message in this conversation.",
              invalidAmount: "Enter an amount of at least 0.01.",
              invalidDescription: "Enter a short description (max 80 chars).",
              sentSuccess: "Payment link sent to the customer.",
              sendFailed: "Failed to send payment link. Please try again.",
              noTerminal: "No Tranzila terminal configured for your company.",
              openSettings: "Open Settings → Payments",
              cancel: "Cancel",
              next: "Next",
              sendNow: "Send payment link"
            },
            aiWorkforcePage: {
              title: "AI Workforce",
              subtitle: "Manage the AI engine — agents, rules, logs and master toggle.",
              notForTenant: {
                title: "Not available for this tenant",
                help: "The AI Workforce console is only used by the GoDeal pipeline. Generic tenants configure AI from the AI Settings page."
              },
              toggle: {
                title: "Master Switch — AI Workforce",
                description: "When off, the entire AI agent pipeline is bypassed completely.",
                enabled: "AI Workforce enabled ✅",
                disabled: "AI Workforce disabled",
                failed: "Failed to toggle AI Workforce"
              },
              tabs: {
                stats: "Statistics",
                rules: "Rules",
                logs: "Action Logs",
                agents: "Agents"
              },
              stats: {
                totalAgents: "Agents",
                activeAgents: "Active",
                totalRules: "Rules",
                totalKnowledge: "Knowledge",
                actionsToday: "Actions Today",
                actionsWeek: "Actions This Week",
                escalationsToday: "Escalations Today",
                successRate: "Success Rate",
                pipelineHealth: "Pipeline Health",
                healthy: "Healthy",
                warning: "Warning",
                critical: "Critical",
                autoRefresh: "Auto-refreshing"
              },
              rules: {
                empty: "No rules defined yet.",
                newRule: "New Rule",
                editRule: "Edit Rule",
                edit: "Edit rule",
                delete: "Delete rule",
                deleted: "Rule deleted",
                created: "Rule created",
                updated: "Rule updated",
                deleteFailed: "Failed to delete rule",
                updateFailed: "Failed to update rule",
                confirmDelete: "Delete rule \"{{name}}\"? This cannot be undone.",
                col: {
                  name: "Name",
                  type: "Type",
                  priority: "Priority",
                  active: "Active",
                  actions: "Actions"
                },
                types: {
                  pricing: "Pricing",
                  commission: "Commission",
                  escalation: "Escalation",
                  handoff: "Handoff to Agent",
                  response_template: "Response Template"
                },
                form: {
                  name: "Rule Name",
                  type: "Rule Type",
                  priority: "Priority",
                  active: "Active",
                  description: "Description (optional)",
                  conditions: "Conditions (JSON)",
                  actions: "Actions (JSON)",
                  jsonHelp: "Schema is engine-specific. For advanced use only.",
                  advancedMode: "Advanced Mode (JSON)",
                  save: "Save",
                  cancel: "Cancel",
                  saveFailed: "Failed to save rule",
                  invalidJson: "Invalid JSON",
                  nameTypeRequired: "Name and Type are required",
                  productTypes: "Product Types",
                  priceFrom: "Min Price (₪)",
                  priceTo: "Max Price (₪)",
                  boardTypes: "Board Types",
                  triggerKeywords: "Trigger Keywords (comma-separated)",
                  confidenceThreshold: "Confidence Threshold (0-100)",
                  commissionRate: "Commission Rate (%)",
                  markupRate: "Markup Rate (%)",
                  escalateTrigger: "Escalation Trigger",
                  handoffMessage: "Handoff Message",
                  responseTemplate: "Response Template"
                }
              },
              logs: {
                empty: "No action logs yet.",
                filterByStatus: "Filter by status",
                allStatuses: "All",
                searchAction: "Search action...",
                expandDetails: "Details",
                inputData: "Input Data",
                outputData: "Output Data",
                col: {
                  when: "When",
                  action: "Action",
                  agent: "Agent",
                  ticket: "Ticket",
                  status: "Status",
                  latency: "Latency",
                  error: "Error"
                }
              },
              agents: {
                title: "Active AI Agents",
                noAgents: "No agents found.",
                roles: {
                  offer_matcher: "Offer Matcher",
                  pricing_calculator: "Pricing Calculator",
                  conversation: "Conversation Agent",
                  supervisor: "Supervisor",
                  queue_manager: "Queue Manager",
                  notification_engine: "Notification Engine",
                  business_intelligence: "Business Intelligence",
                  appointment_scheduler: "Appointment Scheduler"
                },
                calendarConnected: "Calendar connected ✓",
                secretaryName: "AI Secretary — Appointment Scheduling",
                secretarySubtitle: "Calendar-connected — meetings via natural chat"
              },
              refresh: "Refresh"
            },
            aiSettingsPage: {
              title: "AI Settings",
              subtitle: "Configure your AI assistant behavior",
              goToAIWorkforce: "Go to AI Workforce",
              aiWorkforce: {
                title: "AI Workforce",
                description: "Enable or disable all AI processing for this company",
                enabled: "AI Workforce enabled",
                disabled: "AI Workforce disabled",
                toggleFailed: "Failed to toggle AI Workforce"
              },
              saveChanges: "Save Changes",
              saving: "Saving...",
              settingsSaved: "Settings saved!",
              failedToLoad: "Failed to load AI settings",
              failedToSave: "Failed to save settings",
              companyInfo: {
                title: "Company Info",
                companyName: "Company Name",
                companyNameHelp: "The display name of your company. This appears in customer-facing messages and greetings.",
                timezone: "Timezone",
                timezoneHelp: "Set your local timezone. This affects scheduled messages, follow-ups, and working hours.",
                language: "Language",
                languageHelp: "The primary language the AI bot will use when communicating with customers.",
                timezones: {
                  israel: "Israel",
                  uk: "UK",
                  usEast: "US East",
                  ukraine: "Ukraine"
                },
                languages: {
                  hebrew: "Hebrew",
                  english: "English",
                  russian: "Russian",
                  arabic: "Arabic"
                }
              },
              aiBehavior: {
                title: "AI Behavior",
                titleHelp: "Control how the AI responds to customers — its personality, knowledge base, and capabilities.",
                systemPrompt: "System Prompt",
                systemPromptHelp: "Custom instructions for the AI. Describe what the AI should know, how it should behave, what it should never do. This is the most important setting for controlling AI behavior.",
                tone: "Tone",
                toneHelp: "The conversational style of the AI. Professional = business-like, Friendly = casual and warm, Formal = strict and polite.",
                model: "Model",
                modelHelp: "The AI model to use. GPT-5 is most capable but slower/costlier. GPT-4o Mini is fast and affordable for simple tasks.",
                aiEnabled: "AI Agent Enabled",
                tones: {
                  professional: "Professional",
                  friendly: "Friendly",
                  formal: "Formal"
                }
              },
              dataSources: {
                title: "Data Sources",
                description: "External APIs the AI can use to fetch real-time data during conversations.",
                sourceType: "Data Source Type",
                sourceTypeHelp: "How the AI accesses your product/service catalog. REST API = custom API endpoint. Supabase = direct database query. None = no catalog search.",
                none: "None",
                restApi: "REST API",
                supabase: "Supabase",
                supabaseUrl: "Supabase URL",
                supabaseApiKey: "Supabase API Key",
                summaryTemplate: "Summary display template",
                summaryHelperText: "How to show collected data. Use {{fields}} as placeholder.",
                toolName: "Name",
                toolNameHelp: "A descriptive name for this data source. Example: 'Vacation Packages Search', 'Product Catalog'.",
                toolApiUrl: "API URL",
                toolApiUrlHelp: "The full URL of the API endpoint. The AI will call this URL to search for products/services.",
                toolDescription: "Description",
                toolDescriptionHelp: "Explain what this API does in plain language. The AI uses this to decide when to call it. Example: 'Searches vacation packages by destination and dates'.",
                requiredFields: "Required Fields (comma-separated)",
                requiredFieldsPlaceholder: "e.g. category, budget (optional — leave empty for simple catalog)",
                requiredFieldsHelp: "Fields the AI must collect from the customer before calling this API. Leave empty for simple catalog browsing.",
                requiredFieldsHelper: "For simple 'do you have X?' — leave empty. Only add for filtered search.",
                addDataSource: "Add Data Source",
                maxProductCardsHelp: "How many product/service cards to show per search. Lower = faster response, higher = more options for the customer.",
                filterConfigHelp: "Advanced JSON configuration that maps customer intake data to API query parameters. Only edit if you know your API structure."
              },
              categoryStructure: {
                title: "Category Structure",
                titleHelp: "Categories help the AI organize products/services. When a customer asks for something, the AI filters by these categories. You can auto-detect from your data or add manually.",
                description: "The AI uses this structure to understand your data categories and filter items accurately. Scan your data source to auto-detect, or configure manually.",
                autoDetect: "Auto-Detect Categories",
                scanning: "Scanning...",
                autoDetected: "Auto-detected",
                manual: "Manual",
                lastScan: "Last scan",
                categoryField: "Category field name",
                categoryFieldHelper: "The field in your data that contains the category",
                subcategoryField: "Subcategory field name",
                subcategoryFieldHelper: "Optional secondary grouping field",
                items: "items",
                noCategories: "No categories detected yet. Click \"Auto-Detect Categories\" to scan your data source.",
                addManually: "Add Category Manually",
                editName: "Edit name",
                remove: "Remove",
                detected: "Detected {{count}} categories",
                detectionFailed: "Detection failed",
                failedToScan: "Failed to scan categories"
              },
              handoffRules: {
                title: "Handoff Rules",
                titleHelp: "Rules that determine when the AI should stop and transfer the conversation to a human agent. Enable built-in rules or add your own custom conditions.",
                addCustomRule: "Add Custom Rule"
              },
              numberProfiles: {
                title: "WhatsApp Number Profiles",
                description: "Configure AI behavior per WhatsApp number. Each number can have its own bot mode, AI queues, and intake questions.",
                noNumbers: "No WhatsApp numbers found. Add a connection first.",
                saveProfile: "Save Profile",
                saved: "Profile saved!",
                saveFailed: "Failed to save profile",
                modeChatbot: "AI Chatbot (categories → questions → products)",
                modeDirect: "Direct AI (free conversation)",
                modeOff: "Off (classic menu bot only)",
                systemPromptOverride: "System Prompt Override",
                systemPromptOverrideHelp: "Override the company-wide system prompt for this specific number. Leave empty to use the default prompt from General Settings.",
                systemPromptPlaceholder: "Leave empty to use company default prompt",
                aiQueuesTitle: "AI Bot Queues",
                aiQueuesHelp: "Define service categories the customer can choose from. Each queue can have its own intake questions, auto-task creation, and summary template. Example: 'Service Request', 'Billing', 'General Questions'.",
                queueName: "Queue Name",
                queueNameHelp: "The name shown to the customer in the selection menu. Use clear, simple names.",
                queueDescription: "Description",
                queueDescriptionHelp: "A short description of what this queue handles. Helps the AI route customers correctly.",
                addQueue: "Add AI Queue"
              },
              chatbotSettings: {
                title: "Chatbot Settings",
                description: "Configure how the chatbot handles incoming conversations before handing off to an agent.",
                botMode: "Bot Mode",
                botModeHelp: "Choose how the AI interacts with customers. AI Chatbot = structured flow with menus and questions. Direct AI = free-form AI conversation. Off = no AI, classic menu only.",
                botModeMenu: "Menu Bot (classic step-by-step)",
                botModeAI: "AI Bot (conversational)",
                botModeHelper: "Menu bot uses fixed menus. AI bot conducts a natural conversation to collect information.",
                questionsTitle: "Intake Questions",
                questionsHelp: "Questions the bot asks before handing off to a human agent. Each question has a field name (for internal use) and the actual text shown to the customer.",
                questionsDescription: "Define the information AI should collect from the customer before transferring to an agent.",
                addQuestion: "Add Question",
                questionField: "Field name",
                questionFieldHelp: "A short internal name for this data point. Used in templates and CRM sync. Example: name, address, description, budget.",
                questionText: "Question text",
                questionTextHelp: "The exact question the bot will ask the customer. Write it in the customer's language. Example: 'What is your name?'",
                questionRequired: "Required",
                questionRequiredHelp: "If ON, the bot will keep asking until the customer answers. If OFF, the customer can skip this question.",
                questionOptions: "Options (comma-separated)",
                questionOptionsHelp: "Leave empty for free text. E.g.: Electronics, Jewelery, Clothing. 1-3 options = buttons, 4+ = list.",
                noQuestions: "No intake questions configured. The AI will chat freely without collecting specific data.",
                defaultQueue: "Default Queue",
                defaultQueueHelper: "Queue to assign tickets when AI cannot determine the right one",
                noQueue: "No default queue",
                autoCreateTask: "Auto-create task after intake",
                autoCreateTaskHelp: "When ON, a task is automatically created in the system after the customer completes all intake questions. Useful for service requests.",
                summaryTemplate: "Summary Template",
                summaryTemplateHelp: "The confirmation message sent to the customer after completing the intake form. Use {{field}} to insert collected data. Example: 'Name: {{name}}'.",
                summaryTemplatePlaceholder: "e.g. *Request received!*\nName: {{name}}\nAddress: {{address}}",
                summaryTemplateHelper: "Use {{field}} placeholders. Leave empty to use company default."
              },
              greeting: {
                title: "Greeting",
                titleHelp: "The greeting message is sent automatically when a customer messages for the first time or after a long period of inactivity.",
                enableGreeting: "Enable automatic greeting",
                greetingMessage: "Greeting Message",
                greetingMessageHelp: "The first message the customer sees. Include a welcome, your company name, and what the bot can help with."
              },
              sections: {
                general: "General Settings",
                generalDesc: "Company identity, AI model, language, and greeting configuration",
                generalHelp: "Basic settings: your company name, preferred language, AI model, and the greeting message customers see first.",
                chatbotFlow: "Chatbot Flow",
                chatbotFlowDesc: "WhatsApp bot mode, queues, intake questions, and task automation",
                chatbotFlowHelp: "Configure how the bot collects information from customers. Set up menus, intake questions, and automated task creation per WhatsApp number.",
                productSearch: "Product Search",
                productSearchDesc: "Data sources, product filtering, and category structure for catalog search",
                productSearchHelp: "Connect the AI to your product/service catalog. The AI will search and show relevant items to customers during conversations.",
                externalCrm: "External CRM",
                externalCrmDesc: "Connect to an external database (Supabase) for customer lookup, task sync, and payments",
                advanced: "Advanced",
                advancedDesc: "Handoff rules and other advanced configurations",
                advancedHelp: "Define when the AI should stop and transfer the conversation to a human agent.",
                active: "Active"
              },
              crm: {
                enableIntegration: "Enable External CRM Integration",
                connectionTitle: "Connection",
                connectionHelp: "Enter your Supabase project URL and API key. You can find these in your Supabase dashboard under Settings → API.",
                supabaseUrl: "Supabase URL",
                supabaseKey: "Supabase API Key",
                testConnection: "Test Connection",
                edgeFunctionPath: "Edge Function Path (optional)",
                edgeFunctionPathHelp: "If set, queries go through the Edge Function instead of direct REST. Example: /functions/v1/crm-api",
                customerLookupTitle: "Customer Lookup",
                customerLookupHelp: "When a customer sends a WhatsApp message, the bot will search your database by phone number and auto-fill their details (name, address, etc.). This means the bot won't ask questions it already knows the answer to.",
                customerLookupDesc: "Automatically pre-fill customer details from your database when they message. Reduces intake questions.",
                tableName: "Table Name",
                tableNameHelp: "The name of the table in your database that contains customer records. Example: customers, contacts, tenants",
                phoneField: "Phone Column",
                phoneFieldHelp: "The column name in your table that stores phone numbers. Example: phone, mobile, tenant_phone",
                nameFields: "Name Columns",
                nameFieldsHelp: "Comma-separated column names, e.g. first_name, last_name",
                extraField1: "Extra Field 1 (optional)",
                extraField1Help: "Additional field to pre-fill, e.g. address, department, company",
                extraField2: "Extra Field 2 (optional)",
                extraField2Help: "Another field to pre-fill, e.g. apartment, unit, account_id",
                cachedFields: "Cached lookup fields (comma-separated)",
                cachedFieldsHelp: "Extra response keys to remember after the lookup so they can be used later (e.g. building_id, apartment_id, customer_id). Required when your task payload references {notes.<field>}.",
                detectedFields: "Detected columns",
                taskSyncTitle: "Task Sync",
                taskSyncHelp: "Automatically sync tasks created by the bot to your external database. When a customer completes an intake form, a task record is created in your CRM.",
                taskTable: "Task Table",
                syncTasksToCrm: "Sync tasks to CRM",
                defaultTaskType: "Default task type",
                defaultTaskTypeHelp: "Used when nothing in the keyword map matches the queue. Pick a value your CRM always accepts (e.g. repair, general).",
                requireFields: "Required fields (comma-separated)",
                requireFieldsHelp: "Skip the external CRM call if any of these notes-keys is missing. Prevents 400s when the tenant lookup didn't match.",
                taskTypeMap: "Task type map (JSON)",
                taskTypeMapHelp: 'Map each task_type your CRM accepts to a list of keywords. First match wins (case-insensitive substring on the queue name). Example: {"emergency": ["leak","fire"], "repair": ["broken","fix"]}',
                payloadTemplate: "Create-task payload template (JSON)",
                payloadTemplateHelp: "Body shape your CRM expects for create_task. Use {{title}}, {{taskType}}, {{priority}}, {{description}}, {{phone}}, {notes.<field>} placeholders. Leave empty to use a generic default body.",
                advanced: {
                  title: "Advanced — task type & payload mapping",
                  description: "Only fill these in if your CRM enforces a strict task_type enum or a custom body shape. Defaults work for most Supabase setups.",
                  jsonParseError: "Invalid JSON",
                  jsonMustBeObject: "JSON must be an object"
                },
                paymentCheckTitle: "Payment Check",
                paymentCheckHelp: "Allow the bot to check payment status from your database. When a customer asks about payments, the bot can look up their balance and payment history.",
                paymentTable: "Payment Table",
                paymentStatusField: "Status Column"
              },
              companyKnowledge: {
                title: "Company Knowledge",
                description: "Business profile, rules, FAQ — injected into the AI's system prompt for every customer chat.",
                profile: "Business profile",
                overview: "Business overview",
                overviewPlaceholder: "What does your business do, who do you serve? (2-3 sentences)",
                serviceAreas: "Service areas (comma-separated)",
                escalationPhone: "Escalation phone",
                escalationEmail: "Escalation email",
                communication: "Communication style",
                addressForm: "Address form",
                toneStyle: "Tone & style",
                stopTopics: "Topics to AVOID (comma-separated)",
                disclaimers: "Required disclaimers (comma-separated)",
                rules: "Business rules",
                addRule: "Add rule",
                neverDo: "Hard prohibitions",
                addNeverDo: "Add prohibition",
                neverDoPlaceholder: "Never discuss competitor pricing",
                faq: "FAQ",
                addFaq: "Add FAQ",
                faqQuestion: "Question",
                faqAnswer: "Answer"
              }
            },
            sitePages: {
              sidebarHeading: "Pages",
              selectPage: "Select a page to edit",
              loadError: "Failed to load pages",
              saveSuccess: "Page saved",
              saveError: "Save failed",
              statusError: "Status update failed",
              published: "Page published",
              unpublished: "Page set to draft",
              statusPublished: "Published",
              statusDraft: "Draft",
              setDraft: "Set to draft",
              publish: "Publish page",
              save: "Save",
              saving: "Saving…",
              fieldTitle: "Page Title",
              fieldMetaTitle: "Meta Title",
              fieldMetaDesc: "Meta Description",
              fieldBody: "Page Body (HTML)",
              metaTitleHint: "Max 70 characters. Used by Google as the page title in search results.",
              metaDescHint: "Max 160 characters. Shown under the title in Google search results.",
              bodyHint: "Full HTML content of the page. Rendered as-is on whapiz.com.",
              tooLong: "Too long — Google will truncate",
              slugs: {
                termsOfService: "Terms of Service",
                privacyPolicy: "Privacy Policy",
                aboutUs: "About Us",
                cookiePolicy: "Cookie Policy"
              }
            }
          }
        }
      };

export { messages };
